function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);


  if (elementToFocus) {
    elementToFocus.focus();
  }

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
    this._onButtonClick = this.onButtonClick.bind(this);
    this._onInputChange = this.onInputChange.bind(this);
    this._validateQtyRules = this.validateQtyRules.bind(this);
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => {
      button.removeEventListener('click', this._onButtonClick);
      button.addEventListener('click', this._onButtonClick);
    });
    this.input?.removeEventListener('change', this._onInputChange);
    this.input?.addEventListener('change', this._onInputChange);

    if (!this.closest('cart-drawer-items')?._suppressPlusDisable) {
      this.validateQtyRules();
    }

    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this._validateQtyRules);
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  getEffectiveMax(input = this.input) {
    if (!input) return null;

    let max = null;

    const maxAttr = input.getAttribute('max');
    if (maxAttr !== null && maxAttr !== '') {
      const ruleMax = parseInt(maxAttr, 10);
      if (!Number.isNaN(ruleMax)) max = ruleMax;
    }

    const inventoryAttr = input.dataset.inventoryQuantity;
    if (inventoryAttr !== undefined && inventoryAttr !== '') {
      const inventory = parseInt(inventoryAttr, 10);
      const cartQty = parseInt(input.dataset.cartQuantity, 10) || 0;
      const lineQty = parseInt(input.value, 10) || 0;
      if (!Number.isNaN(inventory)) {
        const inventoryMax = inventory - (cartQty - lineQty);
        max = max === null ? inventoryMax : Math.min(max, inventoryMax);
      }
    }

    return max;
  }

  setButtonDisabled(button, disabled) {
    if (!button) return;
    button.classList.toggle('disabled', disabled);
    button.toggleAttribute('disabled', disabled);
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  validateQtyRulesAfterLimitMessage() {
    setTimeout(() => this.validateQtyRules(), CART_QUANTITY_LIMIT_DISABLE_DELAY);
  }

  showDrawerQuantityLimitToast(maxQty) {
    const text = window.cartStrings?.quantityError?.replace('[quantity]', maxQty);
    if (!text) return;

    const toast = document.querySelector('cart-error-toast');
    if (toast && typeof toast.show === 'function') {
      toast.show(text);
    } else {
      publish(PUB_SUB_EVENTS.cartError, { source: 'quantity-input', message: text });
    }

    const cartStatus = document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.textContent = text;
      cartStatus.setAttribute('aria-hidden', 'false');
      setTimeout(() => cartStatus.setAttribute('aria-hidden', 'true'), 1000);
    }
  }

  submitDrawerQuantityChange(button) {
    const cartDrawerItems = this.closest('cart-drawer-items');
    if (!cartDrawerItems || !this.input) return;

    cartDrawerItems.updateQuantity(
      this.input.dataset.index,
      this.input.value,
      button.getAttribute('name'),
      this.input.dataset.quantityVariantId
    );
  }

  onButtonClick(event) {
    const button = event.target.closest('.quantity__button');
    if (!button || button.disabled || button.classList.contains('disabled') || !this.input) return;

    event.preventDefault();
    const previousValue = this.input.value;
    const currentValue = parseInt(this.input.value, 10) || 0;
    const isDrawerQuantity = Boolean(this.closest('cart-drawer-items'));

    if (button.name === 'plus') {
      const effectiveMax = this.getEffectiveMax();
      if (effectiveMax !== null && currentValue >= effectiveMax) {
        if (isDrawerQuantity) {
          this.showDrawerQuantityLimitToast(effectiveMax);
          this.validateQtyRulesAfterLimitMessage();
        } else {
          this.validateQtyRules();
        }
        return;
      }

      if (parseInt(this.input.dataset.min, 10) > parseInt(this.input.step, 10) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (this.input.dataset.min === previousValue && button.name === 'minus') {
      this.input.value = parseInt(this.input.min, 10);
    }

    if (previousValue !== this.input.value) {
      if (isDrawerQuantity) {
        this.submitDrawerQuantityChange(button);
        if (button.name !== 'plus') {
          this.validateQtyRules();
        }
        return;
      }

      this.input.dispatchEvent(this.changeEvent);
    }

    this.validateQtyRules();
  }

  validateQtyRules() {
    if (!this.input) return;

    const value = parseInt(this.input.value, 10) || 0;
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");
    const suppressPlusDisable = Boolean(this.closest('cart-drawer-items')?._suppressPlusDisable);

    if (this.input.min !== '') {
      this.setButtonDisabled(buttonMinus, value <= parseInt(this.input.min, 10));
    }

    const effectiveMax = this.getEffectiveMax();
    if (effectiveMax !== null) {
      this.input.max = effectiveMax;
      this.input.setAttribute('max', String(effectiveMax));
      if (!suppressPlusDisable) {
        this.setButtonDisabled(buttonPlus, value >= effectiveMax);
      }
    } else {
      this.input.removeAttribute('max');
      if (!suppressPlusDisable) {
        this.setButtonDisabled(buttonPlus, false);
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};



class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.collapsible-trigger):not(.market-selector__trigger):not(.market-selector__close):not(.market-selector__language)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.trapLinkLevel1();
    this.trapLink();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);

        const flatSubmenu = detailsElement.querySelector('.menu-drawer__submenu--flat-l1, .menu-drawer__submenu[data-nav-slug="nav-l1-this-is-armada"]');
        if (flatSubmenu) {
          requestAnimationFrame(() => this.syncFlatL1ScrollPanel?.());
          flatSubmenu.addEventListener(
            'transitionend',
            () => this.syncFlatL1ScrollPanel?.(),
            { once: true }
          );
        }
      }, 150);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    this.clearFlatL1ScrollPanel?.();
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    this.clearFlatL1ScrollPanel?.();
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);

  }

  closeAnimation(detailsElement) {
    detailsElement.classList.add('is-closing');
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        
        detailsElement.removeAttribute('open');
        detailsElement.classList.remove('is-closing'); 
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
  setupTrapLinks(selector, getFocusTarget) {
    const trapLinks = this.querySelectorAll(selector);
    if (!trapLinks.length) return;
  
    trapLinks.forEach(link => {
      if (link._handleTrapLinkFocus) {
        link.removeEventListener('focus', link._handleTrapLinkFocus);
        link._handleTrapLinkFocus = null;
      }
    });
  
    trapLinks.forEach(trapLink => {
      trapLink._handleTrapLinkFocus = (event) => {
        event.preventDefault();
  
        const target = getFocusTarget(trapLink);
        if (target) target.focus();
      };
  
      trapLink.addEventListener('focus', trapLink._handleTrapLinkFocus);
    });
  }
  
  trapLink() {
    this.setupTrapLinks('.focus-trap-link', (trapLink) => {
      const submenu = trapLink.closest('.menu-drawer__inner-submenu');
      if (!submenu) return null;
      return submenu.querySelector('.menu-drawer__close-button') || submenu;
    });
  }
  
  trapLinkLevel1() {
    this.setupTrapLinks('.focus-trap-link-close', (trapLink) => {
      const headerDrawer = trapLink.closest('header-drawer');
      if (!headerDrawer) return null;
      return headerDrawer.querySelector('.header__icon--menu');
    });
  }
  
}

customElements.define('menu-drawer', MenuDrawer);


class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const content = document.createElement('div');
    while (this.firstChild) {
      content.appendChild(this.firstChild);
    }
    this.shadowRoot.appendChild(content);

    this.overlay = this.shadowRoot.querySelector('.overlay');
    this.drawer = this.shadowRoot.querySelector('.drawer');
    this.closeButton = this.shadowRoot.querySelector('.close-drawer-btn');

    this.overlay.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
  }

  open() {
    this.setAttribute('open', '');
  }

  close() {
    this.removeAttribute('open');
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open' && newValue !== null) {
      this.style.display = 'block';
    } else {
      this.style.display = 'none';
    }
  }
}

customElements.define('custom-drawer', CustomDrawer);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.open-drawer-btn').forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-target');
      const targetDrawer = document.getElementById(targetId);
      if (targetDrawer) {
        targetDrawer.open();
      }
    });
  });
});


class HeaderDrawer extends MenuDrawer {
  static MOBILE_DRAWER_MQ = '(max-width: 1023px)';

  /** @returns {number} px height of --space-17 (backdrop bleed below viewport). */
  static getSpace17Px() {
    const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return remPx * 16;
  }

  isMobileDrawer() {
    return window.matchMedia(HeaderDrawer.MOBILE_DRAWER_MQ).matches;
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.headerInner = this.header.querySelector('.header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    // Reveal the sticky header before measuring — getBoundingClientRect() on a
    // hidden header (top: -header-height) returns ~0 and breaks drawer offset.
    this.header.classList.add('menu-open');
    this.header.classList.remove('shopify-section-header-hidden');
    this.setHeaderBottomPosition();

    this.mainDetailsToggle.classList.add('is-opening');

    requestAnimationFrame(() => {
      this.setHeaderBottomPosition();
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.classList.add('menu-opening');
      this.syncMenuBackdrop();

      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('is-opening');
      }, 300);
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    if (this.isMobileDrawer()) {
      document.documentElement.classList.add('menu-drawer-open');
      this.lockBodyScroll();
      this.showMenuBackdrop();
      this.bindMenuBackdropViewport();
      this.syncMenuBackdrop();
    }
  }

  lockBodyScroll() {
    if (this._bodyScrollLocked) return;
    this._scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    this._bodyScrollLocked = true;
  }

  unlockBodyScroll() {
    if (!this._bodyScrollLocked) return;
    const scrollY = this._scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    this._bodyScrollLocked = false;
    this._scrollY = 0;
  }

  showMenuBackdrop() {
    if (!this.menuBackdrop) {
      this.menuBackdrop = document.createElement('div');
      this.menuBackdrop.className = 'menu-drawer-backdrop';
      this.menuBackdrop.setAttribute('aria-hidden', 'true');
    }
    if (!this.menuBackdrop.isConnected) {
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup?.parentNode) {
        headerGroup.parentNode.insertBefore(this.menuBackdrop, headerGroup);
      } else {
        document.body.prepend(this.menuBackdrop);
      }
    }
  }

  hideMenuBackdrop() {
    this.menuBackdrop?.remove();
  }

  bindMenuBackdropViewport() {
    if (this._menuBackdropViewportBound || !window.visualViewport) return;
    this._onMenuBackdropViewport = () => this.syncMenuBackdrop();
    window.visualViewport.addEventListener('resize', this._onMenuBackdropViewport);
    window.visualViewport.addEventListener('scroll', this._onMenuBackdropViewport);
    this._menuBackdropViewportBound = true;
  }

  unbindMenuBackdropViewport() {
    if (!this._menuBackdropViewportBound || !window.visualViewport) return;
    window.visualViewport.removeEventListener('resize', this._onMenuBackdropViewport);
    window.visualViewport.removeEventListener('scroll', this._onMenuBackdropViewport);
    this._menuBackdropViewportBound = false;
  }

  syncMenuBackdrop() {
    if (!this.menuBackdrop?.isConnected) return;

    const vv = window.visualViewport;
    const backdropBleed = HeaderDrawer.getSpace17Px();

    if (vv) {
      const layoutHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight,
        vv.height + vv.offsetTop
      );
      this.menuBackdrop.style.height = `${layoutHeight + backdropBleed}px`;
    } else {
      this.menuBackdrop.style.height = '';
    }

    this.menuBackdrop.style.top = '0px';
    this.menuBackdrop.style.bottom = 'auto';

    this.syncMenuDrawerBottom();
  }

  syncMenuDrawerBottom() {
    const root = document.documentElement;

    if (!this.isMobileDrawer() || !this.mainDetailsToggle?.hasAttribute('open')) {
      root.style.removeProperty('--menu-drawer-bottom-bleed');
      return;
    }

    const vv = window.visualViewport;
    if (!vv) {
      root.style.setProperty('--menu-drawer-bottom-bleed', '0px');
      return;
    }

    const bleed = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
    root.style.setProperty('--menu-drawer-bottom-bleed', `${bleed}px`);
  }

  setHeaderBottomPosition() {
    if (!this.header) return;

    const headerInner = this.headerInner || this.header.querySelector('.header');
    const measuredBottom = headerInner
      ? headerInner.getBoundingClientRect().bottom - this.borderOffset
      : 0;
    const fallbackHeight =
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 56;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${Math.max(Math.round(measuredBottom), fallbackHeight)}px`
    );
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.documentElement.classList.remove('menu-drawer-open');
    document.documentElement.style.removeProperty('--menu-drawer-bottom-bleed');
    this.unbindMenuBackdropViewport();
    this.hideMenuBackdrop();
    this.unlockBodyScroll();
    this.clearFlatL1ScrollPanel();
  }

  onResize = () => {
    this.setHeaderBottomPosition();
    this.syncMenuBackdrop();
    this.syncFlatL1ScrollPanel();
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

  getFlatL1OpenPanel() {
    return this.querySelector(
      'details.menu-drawer__menu-lv-1[open].menu-opening > .menu-drawer__submenu--flat-l1, ' +
        'details.menu-drawer__menu-lv-1[open].menu-opening > .menu-drawer__submenu[data-nav-slug="nav-l1-this-is-armada"]'
    );
  }

  syncFlatL1ScrollPanel() {
    if (!this.isMobileDrawer()) return;

    const panel = this.getFlatL1OpenPanel();
    const inner = panel?.querySelector('.menu-drawer__inner-submenu');
    const header = inner?.querySelector('.menu-drawer__close-button');
    const content = inner?.querySelector('.menu-drawer__submenu-content');

    this.querySelectorAll('.menu-drawer__submenu-content--flat-l1-scroll').forEach((el) => {
      if (el !== content) {
        el.classList.remove('menu-drawer__submenu-content--flat-l1-scroll');
        el.style.removeProperty('--flat-l1-scroll-height');
      }
    });

    if (!panel || !inner || !header || !content) return;

    const scrollHeight = Math.max(
      0,
      Math.floor(
        panel.getBoundingClientRect().height -
          header.getBoundingClientRect().height -
          parseFloat(getComputedStyle(panel).paddingBottom || '0')
      )
    );

    content.style.setProperty('--flat-l1-scroll-height', `${scrollHeight}px`);
    content.classList.add('menu-drawer__submenu-content--flat-l1-scroll');
    this.bindFlatL1ScrollViewport();
  }

  clearFlatL1ScrollPanel() {
    this.querySelectorAll('.menu-drawer__submenu-content--flat-l1-scroll').forEach((el) => {
      el.classList.remove('menu-drawer__submenu-content--flat-l1-scroll');
      el.style.removeProperty('--flat-l1-scroll-height');
    });
    this.unbindFlatL1ScrollViewport();
  }

  bindFlatL1ScrollViewport() {
    if (this._flatL1ScrollViewportBound || !window.visualViewport) return;
    this._onFlatL1ScrollViewport = () => this.syncFlatL1ScrollPanel();
    window.visualViewport.addEventListener('resize', this._onFlatL1ScrollViewport);
    window.visualViewport.addEventListener('scroll', this._onFlatL1ScrollViewport);
    this._flatL1ScrollViewportBound = true;
  }

  unbindFlatL1ScrollViewport() {
    if (!this._flatL1ScrollViewportBound || !window.visualViewport) return;
    window.visualViewport.removeEventListener('resize', this._onFlatL1ScrollViewport);
    window.visualViewport.removeEventListener('scroll', this._onFlatL1ScrollViewport);
    this._flatL1ScrollViewportBound = false;
    this._onFlatL1ScrollViewport = null;
  }
}

customElements.define('header-drawer', HeaderDrawer);



class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;
    // Copy that must not sit in the HTML until the dialog is opened (crawlers
    // read hidden text), e.g. the back-in-stock "sold out" line.
    this.querySelectorAll('[data-open-text]').forEach((el) => {
      if (!el.textContent.trim()) el.textContent = el.dataset.openText;
    });
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    document.addEventListener('keydown', this.handleKeyDown);

    // Engage focus trap after the drawer has slid into view (~550ms).
    // Kept in sync with the choreographed open: overlay 0–550ms, content slides
    // in 250–850ms.
    setTimeout(() => {
      const dialogEl = this.querySelector('[role="dialog"]');
      const firstFocusableElement = this.querySelector('a, input, button, [tabindex]:not([tabindex="-1"])');
      trapFocus(dialogEl || this, firstFocusableElement);
    }, 550);
  }

  hide() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.setAttribute('closing', 'true');
    // Wait for full choreographed close: drawer slides out (0–350ms),
    // then overlay blur fades (150–500ms). Keep in sync with modal CSS.
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      this.removeAttribute('closing');
      removeTrapFocus(this.openedBy);
    }, 500);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


// --- API Loading Functions (loadYouTubeApi, loadVimeoApi) remain the same ---

let onYouTubeApiReadyPromise = null;
function loadYouTubeApi() {
  if (!onYouTubeApiReadyPromise) {
    onYouTubeApiReadyPromise = new Promise((resolve) => {
      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }
      const existingCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (existingCallback) {
          existingCallback();
        }
        resolve();
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
    });
  }
  return onYouTubeApiReadyPromise;
}

let vimeoApiPromise = null;
function loadVimeoApi() {
  if (!vimeoApiPromise) {
    vimeoApiPromise = new Promise((resolve) => {
      if (window.Vimeo && window.Vimeo.Player) {
        resolve();
        return;
      }
       if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
          const tag = document.createElement('script');
          tag.src = "https://player.vimeo.com/api/player.js";
          tag.onload = resolve;
          document.head.appendChild(tag);
       } else {
         const checkVimeo = setInterval(() => {
            if (window.Vimeo && window.Vimeo.Player) {
               clearInterval(checkVimeo);
               resolve();
            }
         }, 100);
       }
    });
  }
  return vimeoApiPromise;
}


class DeferredMedia extends HTMLElement {
  static get observedAttributes() {
    return ['playing'];
  }

  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.template = this.querySelector('template');
    this.mediaElement = null;
    this.playerController = null;
    this.mediaKind = null;
    this.boundActivate = this.activate.bind(this);
    this.visibilityObserver = null;
    this.playPauseButton = null;
    this.boundHandlePlayPauseClick = this._handlePlayPauseClick.bind(this);

    if (!this.poster || !this.template) { return; }
    this.poster.addEventListener('click', this.boundActivate);
  }

  connectedCallback() {
    if (this.hasAttribute('autoplay')) {
      this._initiateAutoplayObserver();
    }
  }

  disconnectedCallback() {
    if (this.poster) {
      this.poster.removeEventListener('click', this.boundActivate);
    }
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
      this.visibilityObserver = null;
    }
    if (this.playPauseButton) {
       this.playPauseButton.removeEventListener('click', this.boundHandlePlayPauseClick);
       this.playPauseButton = null;
    }
    this.removeAttribute('has-play-pause-button');

    if (this.playerController && typeof this.playerController.destroy === 'function') {
       try { this.playerController.destroy(); } catch(e) {}
    } else if (this.mediaKind === 'video' && this.mediaElement) {
        this.mediaElement.pause();
    } else if (this.mediaKind === 'model' && this.playerController && typeof this.playerController.pause === 'function') {
        try { this.playerController.pause(); } catch(e) {}
    }
    this._detachStateListeners();
    this.playerController = null;
    this.mediaElement = null;
  }

  activate() {
    if (this.hasAttribute('playing')) return;

    if (!this.getAttribute('loaded')) {
      this._initializeMedia().then(loaded => {
        if (loaded) {
          this._initiatePlayback();
        }
      }).catch(error => {
         console.error("DeferredMedia: Error initializing media:", error);
      });
    } else {
      this._initiatePlayback();
    }
  }

  pause() {
    if (!this.hasAttribute('playing') || (!this.mediaElement && !this.playerController)) return;

    if (this.playerController) {
      if (this.mediaKind === 'youtube' && typeof this.playerController.pauseVideo === 'function') {
        this.playerController.pauseVideo();
      } else if (this.mediaKind === 'vimeo' && typeof this.playerController.pause === 'function') {
        this.playerController.pause();
      } else if (this.mediaKind === 'model' && typeof this.playerController.pause === 'function') {
        try { this.playerController.pause(); } catch(e) {}
      }
    } else if (this.mediaKind === 'video' && this.mediaElement) {
      this.mediaElement.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing' && this.hasAttribute('loaded')) {
      this._updatePlayPauseButtonState(newValue !== null);
      if (newValue !== null) {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true, detail: this }));
        const group = this.getAttribute('group');
        if (group) {
          document.querySelectorAll(`deferred-media[group="${group}"], product-model[group="${group}"]`).forEach(item => {
            if (item !== this && typeof item.pause === 'function') {
              item.pause();
            }
          });
        }
      } else {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true, detail: this }));
      }
    }
  }

  _initiatePlayback() {
     if (!this.mediaElement && !this.playerController) {
       return;
     }

     if (this.playerController) {
        if (this.mediaKind === 'youtube' && typeof this.playerController.playVideo === 'function') {
          this.playerController.playVideo();
        } else if (this.mediaKind === 'vimeo' && typeof this.playerController.play === 'function') {
          this.playerController.play().catch(error => console.error("Vimeo play error:", error));
        } else if (this.mediaKind === 'model' && typeof this.playerController.play === 'function') {
           try { this.playerController.play(); } catch(e) {}
        }
     } else if (this.mediaKind === 'video' && this.mediaElement) {
        const playPromise = this.mediaElement.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            if (error.name === "NotAllowedError") { this.mediaElement.controls = true; }
          });
        }
     }
  }

  async _initializeMedia(focus = false) {
    if (this.getAttribute('loaded')) return true;
    if (!this.template || !this.template.content || !this.template.content.firstElementChild) return false;

    const container = document.createElement('div');
    const elementContent = this.template.content.cloneNode(true);
    container.appendChild(elementContent);

    const mediaNode = container.querySelector('video, iframe, model-viewer');
    const playPauseButtonNode = container.querySelector('.deferred-media-control__play-pause');

    if (!mediaNode) return false;

    this.mediaElement = mediaNode;
    this.appendChild(this.mediaElement);
    this.setAttribute('loaded', true);

    if (playPauseButtonNode) {
        this.appendChild(playPauseButtonNode);
        this.playPauseButton = playPauseButtonNode;
        if (this.hasAttribute('autoplay')) {
            this.playPauseButton.addEventListener('click', this.boundHandlePlayPauseClick);
            this.setAttribute('has-play-pause-button', '');
            this._updatePlayPauseButtonState(true);
        }
    }

    const nodeName = this.mediaElement.nodeName;

    if (nodeName === 'VIDEO') {
        this.mediaKind = 'video';
        this._attachStateListeners();
    } else if (nodeName === 'IFRAME') {
        const source = this.mediaElement.getAttribute('src') || '';
        if (source.includes('youtube.com') || source.includes('youtu.be')) {
            this.mediaKind = 'youtube';
            if (!this.mediaElement.id) {
                this.mediaElement.id = `deferred-yt-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
            }
            try {
                await loadYouTubeApi();
                this.playerController = new YT.Player(this.mediaElement.id, {
                    events: { 'onStateChange': this._handleYouTubeStateChange.bind(this) }
                });
            } catch(error) {
                console.error("YouTube Player init error:", error);
                this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
            }
        } else if (source.includes('vimeo.com')) {
            this.mediaKind = 'vimeo';
             try {
                 await loadVimeoApi();
                 this.playerController = new Vimeo.Player(this.mediaElement);
                 this._attachVimeoListeners();
             } catch(error) {
                 console.error("Vimeo Player init error:", error);
                 this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
             }
        } else {
            this.mediaKind = 'iframe_unknown';
        }
    } else if (nodeName === 'MODEL-VIEWER') {
        this.mediaKind = 'model';
    } else {
         this.mediaKind = 'unknown';
         this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
    }

    if(this.poster) {
        this.poster.style.display = 'none';
        this.poster.removeEventListener('click', this.boundActivate);
    }

    if (focus && this.mediaElement && typeof this.mediaElement.focus === 'function') {
        try { this.mediaElement.focus(); } catch (e) {}
    }

    return true;
  }

  _attachStateListeners() {
      if (!this.mediaElement || this.mediaKind !== 'video') return;
      this._detachStateListeners();
      this._stateListeners = {
          play: () => this.setAttribute('playing', ''),
          pause: () => this.removeAttribute('playing'),
          ended: () => this.removeAttribute('playing')
      };
      this.mediaElement.addEventListener('play', this._stateListeners.play);
      this.mediaElement.addEventListener('pause', this._stateListeners.pause);
      this.mediaElement.addEventListener('ended', this._stateListeners.ended);
  }

  _handleYouTubeStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
          this.setAttribute('playing', '');
      } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.BUFFERING) {
          this.removeAttribute('playing');
      }
  }

  _attachVimeoListeners() {
      if(!this.playerController || this.mediaKind !== 'vimeo') return;
      this._detachStateListeners();
      this._stateListeners = {
          play: () => this.setAttribute('playing', ''),
          pause: () => this.removeAttribute('playing'),
          ended: () => this.removeAttribute('playing')
      };
      this.playerController.on('play', this._stateListeners.play);
      this.playerController.on('pause', this._stateListeners.pause);
      this.playerController.on('ended', this._stateListeners.ended);
  }

  _detachStateListeners() {
      const listeners = this._stateListeners;
      if (this.mediaElement && this.mediaKind === 'video' && listeners) {
          this.mediaElement.removeEventListener('play', listeners.play);
          this.mediaElement.removeEventListener('pause', listeners.pause);
          this.mediaElement.removeEventListener('ended', listeners.ended);
      }
      else if (this.playerController && this.mediaKind === 'vimeo' && listeners) {
          try {
              this.playerController.off('play', listeners.play);
              this.playerController.off('pause', listeners.pause);
              this.playerController.off('ended', listeners.ended);
          } catch(e) {}
      }
      else if (this.mediaElement && this.mediaKind === 'model' && listeners) {
           try {
               this.mediaElement.removeEventListener('shopify_model_viewer_ui_toggle_play', listeners.play);
               this.mediaElement.removeEventListener('shopify_model_viewer_ui_toggle_pause', listeners.pause);
           } catch(e) {}
      }
      this._stateListeners = null;
  }

  _initiateAutoplayObserver() {
    if (this.visibilityObserver || !('IntersectionObserver' in window)) {
      return;
    }
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.1 };
    this.visibilityObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAttribute('playing') && !this.getAttribute('loaded')) {
          this.activate();
          observer.disconnect();
          this.visibilityObserver = null;
        }
      });
    }, observerOptions);
    this.visibilityObserver.observe(this);
  }

  _handlePlayPauseClick() {
    if (this.hasAttribute('playing')) {
      this.pause();
    } else {
      this.activate();
    }
  }

  _updatePlayPauseButtonState(isPlaying) {
    if (!this.playPauseButton) return;
    if (isPlaying) {
      this.playPauseButton.classList.remove('is-paused');
      this.playPauseButton.classList.add('is-playing');
      this.playPauseButton.setAttribute('aria-label', 'Pause');
    } else {
      this.playPauseButton.classList.remove('is-playing');
      this.playPauseButton.classList.add('is-paused');
      this.playPauseButton.setAttribute('aria-label', 'Play');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);




class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  connectedCallback() {
    this.getVariantData();
    this.refreshVariantState({ initial: true });
  }

  onVariantChange(event) {
    this.refreshVariantState({ event });
  }

  refreshVariantState({ event = null, initial = false } = {}) {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant && this.reconcileOptionCombination()) {
      this.updateOptions();
      this.updateMasterId();
    }
    if (event?.target) this.updateSelectedSwatchValue(event);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateVariantText();
    this.updateSoldOutState();
    this.updateHeaderBadge();
    this.updateButtonPrice();
    this.syncSubmitButtonState({ initial });
  }

  syncSubmitButtonState({ initial = false } = {}) {
    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    const soldOut = !this.currentVariant.available;
    this.toggleAddButton(soldOut);
    this.toggleStickyAddButton(soldOut);
    this.updateVariantInput();
    this.updateWishlistVariant();
    this.syncPriceWithVariant(this.dataset.section);
    if (this.currentVariant.available) {
      this.scheduleAvailablePriceSync(this.dataset.section);
    } else {
      // Regios embed paints after init and can re-show a fake sale stack on
      // sold-out PDPs — re-assert the single regular price for a short window.
      this.scheduleSoldOutPriceSync(this.dataset.section);
    }

    if (initial) return;

    this.updateURL();
    this.renderProductInfo();
    this.updateShareUrl();
    this.updateCarousel();
  }

  /**
   * When the picked colour/size pair is not a real Shopify variant, try to
   * keep upstream choices (e.g. colour) and snap downstream options (e.g. size)
   * to the first variant that exists — including sold-out ones — so shoppers
   * see "Join the waiting list" instead of a dead "Unavailable" CTA.
   */
  reconcileOptionCombination() {
    if (this.currentVariant) return false;

    const variants = this.getVariantData();
    if (!variants?.length) return false;

    // Iterate the same element set (and order) as updateOptions() so that
    // `index` lines up with this.options[index] and variant.options[index].
    // Hidden/forced fieldsets must be counted — skipping them shifts every
    // later index and snaps the wrong option.
    const optionElements = [...this.querySelectorAll('select, fieldset')];
    if (!optionElements.length) return false;

    let candidateVariants = variants;
    let changed = false;

    optionElements.forEach((element, index) => {
      const radios = [...element.querySelectorAll('input[type="radio"]')];

      // Only snap visible, radio-based fieldsets. Hidden/forced options and
      // selects keep the value updateOptions() already captured, but still
      // narrow the candidate pool below.
      if (radios.length && !element.hidden) {
        const selected = this.options[index];
        const hasMatch =
          selected && candidateVariants.some((variant) => variant.options[index] === selected);

        if (!hasMatch) {
          const fallback = candidateVariants.find((variant) => variant.options[index])?.options[index];
          if (fallback) {
            const targetRadio = radios.find((radio) => radio.value === fallback);
            if (targetRadio && !targetRadio.checked) {
              radios.forEach((radio) => {
                radio.checked = false;
              });
              targetRadio.checked = true;
              changed = true;
            }
          }
        }
      }

      const checkedValue = radios.find((radio) => radio.checked)?.value ?? this.options[index];

      if (checkedValue) {
        candidateVariants = candidateVariants.filter(
          (variant) => variant.options[index] === checkedValue
        );
      }
    });

    return changed;
  }

  updateCarousel() {
    const updateCarouselForElement = (element) => {
      if (element && this.currentVariant.featured_media) {
        element.updateCarouselImages(this.currentVariant.featured_media.id);
      }
    };
    const galleryCarousel = document.getElementById(`Gallery-carousel-${this.dataset.section}`);
    updateCarouselForElement(galleryCarousel);
    const quickViewContainer = document.querySelector('.product-modal-content');
    if (quickViewContainer) {
      const galleryCarouselQuickView = quickViewContainer.querySelector(`#Gallery-carousel-${this.dataset.section}`);
      updateCarouselForElement(galleryCarouselQuickView);
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }
  updateVariantText() {
    this.querySelectorAll('.product-form__input').forEach((item, i) => 
      item.querySelector('.form__label-value').innerHTML = this.options[i]
    );
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }


  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton ) return;
    shareButton.setAttribute('data-url', `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* AAS-5630: the toggle is stamped with the variant the page loaded with, so
     without this the wishlist saves that one however the picker was changed.
     Narrowed to this product's own toggles — a product page also lists
     recommendations, and those belong to other products. */
  updateWishlistVariant() {
    const handle = (this.dataset.url || '').split('?')[0].split('/').filter(Boolean).pop();
    if (!handle) return;

    window.armadaSyncWishlistVariant?.(document, this.currentVariant.id, handle);
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const selectedUpstreamOptions = this.options.slice(0, index);
      const availableOptionInputsValue = this.variantData
        .filter((variant) => variant.available)
        .filter((variant) =>
          selectedUpstreamOptions.every((selectedValue, selectedIndex) => {
            if (!selectedValue) return true;
            return variant[`option${selectedIndex + 1}`] === selectedValue;
          })
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        const shouldDisable = !availableElement && !element.checked;
        element.classList.toggle('disabled', shouldDisable);
        // The server only writes the "sold out" copy into unavailable values
        // (snippets/product-variant-options.liquid), so keep it in step here.
        const unavailableLabel = element.nextElementSibling?.querySelector('.label-unavailable');
        if (unavailableLabel) unavailableLabel.textContent = shouldDisable ? unavailableLabel.dataset.text || '' : '';
      } else if (element.tagName === 'OPTION') {
        const shouldDisable = !availableElement && !element.selected;
        element.innerText = shouldDisable
          ? window.variantStrings.unavailable_with_option.replace('[value]', value)
          : value;
        element.classList.toggle('disabled', shouldDisable);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
   
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateSoldOutState() {
    const variantInput = document.getElementById(`ContactFormSoldout-variant-${this.dataset.section}`);
    if (!variantInput || !this.currentVariant) return;

    variantInput.value = this.currentVariant.title;
    variantInput.dataset.productSku = this.currentVariant.sku || '';
    variantInput.dataset.variantId = `gid://shopify/ProductVariant/${this.currentVariant.id}`;
  }

  getBackInStockModalSelector() {
    const modal = document.querySelector(`[id^="modal-back-in-stock-${this.dataset.section}-"]`);
    return modal ? `#${modal.id}` : '';
  }

  /**
   * Three states, mirroring snippets/buy-buttons.liquid: buyable, sold out
   * with the waitlist (theme setting enable_back_in_stock on — button opens
   * the back-in-stock modal), or sold out without it (disabled "Sold out").
   * data-sold-out is set in every sold-out state so the section re-fetch can
   * read availability off the button whether or not the waitlist is on.
   */
  setSubmitButtonWaitlistMode(button, labelEl, opener, soldOut) {
    if (!button) return;

    const waitlist = soldOut && window.theme?.settings?.enable_back_in_stock !== false;
    const modalSelector = waitlist ? this.getBackInStockModalSelector() : '';

    button.type = soldOut ? 'button' : 'submit';
    button.toggleAttribute('disabled', soldOut && !waitlist);
    button.toggleAttribute('data-sold-out', soldOut);
    button.toggleAttribute('data-waitlist', waitlist);
    button.classList.toggle('product-form__submit--waitlist', waitlist);
    if (soldOut) button.removeAttribute('name');
    else button.setAttribute('name', 'add');
    if (waitlist) button.setAttribute('aria-haspopup', 'dialog');
    else button.removeAttribute('aria-haspopup');

    if (labelEl) {
      if (waitlist) labelEl.textContent = window.variantStrings.joinWaitingList;
      else if (soldOut) labelEl.textContent = window.variantStrings.soldOut;
      else
        labelEl.textContent = button.hasAttribute('data-preorder')
          ? window.variantStrings.preOrder
          : window.variantStrings.addToCart;
    }

    if (opener) {
      opener.classList.toggle('product-form__submit-opener--waitlist', waitlist);
      if (modalSelector) opener.setAttribute('data-modal', modalSelector);
      else opener.removeAttribute('data-modal');
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant) {
          return;
        }
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateStickyImage(sectionId, html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        /* Price classes + amounts come from syncPriceWithVariant (variant JSON).
           Do not replace #price-* innerHTML — section re-fetch can resolve the
           wrong variant for sold-out / $0 cases and overwrite availability classes. */
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }
        
        /* Product header code (desktop + mobile placements). The value is
           variant-level — PIM: Article Code, falling back to the variant SKU —
           and differs per colour, so mirror each placement from its counterpart
           in the fetched section HTML. Do not derive it from the standalone
           #Sku-* block: no product template renders that block, and it holds the
           raw SKU rather than the article code. */
        const headerSkuSectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        ['ProductHeader-Sku', 'ProductHeader-Sku-Mobile'].forEach((idPrefix) => {
          const source = html.getElementById(`${idPrefix}-${headerSkuSectionId}`);
          const destination = document.getElementById(`${idPrefix}-${this.dataset.section}`);
          if (!source || !destination) return;

          const headerSkuEmpty = source.dataset.skuEmpty === 'true';
          destination.textContent = source.textContent.trim();
          destination.dataset.skuEmpty = headerSkuEmpty ? 'true' : 'false';
          destination.classList.toggle('visibility-hidden', headerSkuEmpty);
        });

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('data-sold-out') : true);
        const stickyAddButtonUpdated = html.getElementById(`StickyProductSubmitButton-${sectionId}`);
        this.toggleStickyAddButton(
          stickyAddButtonUpdated ? stickyAddButtonUpdated.hasAttribute('data-sold-out') : true
        );

        this.syncPriceWithVariant(this.dataset.section);
        if (this.currentVariant?.available) {
          this.scheduleAvailablePriceSync(this.dataset.section);
        } else if (this.currentVariant) {
          this.scheduleSoldOutPriceSync(this.dataset.section);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  updateButtonPrice() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
  
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
  
    const buttonPriceEl = addButton.querySelector('.buttonPrice');
  
    if (!buttonPriceEl) return;
  
    if (this.currentVariant) {
      buttonPriceEl.textContent = `— ${formatMoney(
        this.currentVariant.price,
        window.theme.settings.money_with_currency_format
      )}`;
    } else {
      buttonPriceEl.textContent = ''; 
    }
  }

  /**
   * Show the title-row badges that apply to the selected variant.
   * Sale and sold-out are variant-level, but the badge is not part of the
   * section re-fetch mirror (that request resolves the wrong variant for
   * sold-out / $0 cases). The section therefore renders every candidate up
   * front and this un-hides the ones that match. The precedence is the same
   * chain sections/main-product.liquid uses server-side — change both
   * together. AAS-4965
   */
  updateHeaderBadge() {
    const row = document.getElementById(`ProductHeader-TitleRow-${this.dataset.section}`);
    const candidates = row ? row.querySelectorAll('[data-badge-state]') : [];
    if (!candidates.length) return;

    const variant = this.currentVariant;
    const available = !!variant?.available;
    const onSale = variant?.compare_at_price != null && variant.compare_at_price > variant.price;
    const hasCandidate = (state) => !!row.querySelector(`[data-badge-state="${state}"]`);

    /* Sold-out (Coming Soon) and SALE are exclusive — a variant nobody can buy
       reads Coming Soon, never Sale. The static badge can sit beside either;
       'default' stands in when nothing else applies. */
    const activeStates = new Set();
    if (!available) activeStates.add('sold-out');
    else if (onSale) activeStates.add('sale');
    if (hasCandidate('static')) activeStates.add('static');
    if (!activeStates.size && hasCandidate('default')) activeStates.add('default');

    /* Hidden candidates carry no text (snippets/product-header-badge.liquid),
       so crawlers never read an inactive badge; write the copy in on reveal. */
    candidates.forEach((candidate) => {
      const active = activeStates.has(candidate.dataset.badgeState);
      candidate.classList.toggle('hidden', !active);
      candidate.textContent = active ? candidate.dataset.badgeText || '' : '';
    });

    // The title/badge row collapses to a single line only when the badge fits
    // beside the title, so re-measure once the visible badge has changed.
    document.dispatchEvent(new CustomEvent('pdp:header-badge-updated'));
  }

  /**
   * Keep PDP price markup aligned with the authoritative variant JSON.
   * Section re-fetch + the Regios embed can briefly (or permanently) paint
   * the wrong availability state when switching between in-stock and sold-out
   * variants — especially when compare_at > price or price is 0.
   */
  syncPriceWithVariant(sectionId) {
    const variant = this.currentVariant;
    if (!variant || sectionId == null) return;

    const moneyFmt = window.theme?.settings?.money_with_currency_format;
    const formatVariantMoney = (amount) => {
      if (typeof formatMoney !== 'function' || !moneyFmt) return null;
      const tmp = document.createElement('div');
      tmp.innerHTML = formatMoney(amount, moneyFmt);
      return tmp.textContent;
    };

    const formattedPrice = formatVariantMoney(variant.price);
    const formattedCompareAt =
      variant.compare_at_price != null ? formatVariantMoney(variant.compare_at_price) : null;
    const onSale =
      variant.available &&
      variant.compare_at_price != null &&
      variant.compare_at_price > variant.price;
    /* Availability-independent: mirrors the data-native-sale flag price.liquid
       stamps, which tells regios-dopp-sync.js not to tear down a theme-owned
       sale stack. Re-stamped per variant because the price DOM is not re-fetched
       on variant change, so the server value would otherwise go stale. */
    const nativeSale =
      variant.compare_at_price != null && variant.compare_at_price > variant.price;

    // Currency-agnostic: armada-money renders suffix currencies too ("0,00 kr",
    // "0,00 zł", "CHF 0,00"), so match on digits rather than a symbol prefix.
    const isZeroMoney = (text) => {
      const digits = String(text ?? '').replace(/\D/g, '');
      return digits !== '' && /^0+$/.test(digits);
    };

    [`#price-${sectionId} .price`, `#price-${sectionId}-sticky .price`].forEach((selector) => {
      const priceRoot = document.querySelector(selector);
      if (!priceRoot) return;

      priceRoot.dataset.nativeSale = nativeSale ? 'true' : 'false';

      const container = priceRoot.querySelector('.regios-dopp-generic-price-container');
      const regularBlock = container?.querySelector('.price__regular');
      const saleBlock = container?.querySelector('.price__sale');
      const regularPriceEl = regularBlock?.querySelector(':scope > .price-item--regular');
      const regiosDiscountActive = container?.classList.contains('regios-dopp-generic-price--on-sale');

      if (!variant.available) {
        priceRoot.classList.add('price--sold-out');
        const salePriceEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--sale');
        const compareEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--regular');
        const percentEl = saleBlock?.querySelector('.regios-dopp-generic-percent');
        const saleText = salePriceEl?.textContent?.trim();
        const compareText = compareEl?.textContent?.trim();

        /* Sold-out + real Regios discount (DE market OOS) keeps the sale stack.
           The pair must be proven to belong to THIS variant: Regios paints the
           variant's own price as the struck original (or the native compare_at
           when there is one). Trusting leftover DOM text instead would latch the
           previously selected variant's prices onto a sold-out variant — and
           because scheduleSoldOutPriceSync re-reads the same DOM 11x over 5s, it
           would re-confirm the stale reading rather than converge. */
        const canValidate = !!formattedPrice || !!formattedCompareAt;
        const compareBelongsToVariant =
          !!compareText &&
          !isZeroMoney(compareText) &&
          // Without the theme money formatter there is nothing to compare
          // against; fall back to trusting Regios' own container flag.
          (!canValidate ||
            compareText === formattedPrice ||
            (!!formattedCompareAt && compareText === formattedCompareAt));
        /* A native compare_at on the variant needs no Regios validation — it is
           authoritative and comes straight from the variant JSON. Without this,
           a sold-out discounted variant fell through to the blanking path below,
           which wiped the struck original that Liquid had rendered; the 11 re-runs
           of scheduleSoldOutPriceSync then fought the Regios paint and the price
           visibly flickered (AAS-4965). */
        const nativeDiscount = nativeSale;
        const realDiscount =
          nativeDiscount ||
          (!!regiosDiscountActive && !!saleText && compareBelongsToVariant && saleText !== compareText);

        if (realDiscount) {
          priceRoot.classList.add('price--on-sale');
          container?.classList.add('regios-dopp-generic-price--on-sale');
          saleBlock?.style.setProperty('display', 'flex', 'important');
          regularBlock?.style.setProperty('display', 'none', 'important');
          /* Repaint from the variant JSON so a stale pair left by the previously
             selected colour cannot survive the swap. */
          if (nativeDiscount) {
            if (salePriceEl && formattedPrice) salePriceEl.textContent = formattedPrice;
            if (compareEl && formattedCompareAt) compareEl.textContent = formattedCompareAt;
            if (percentEl) {
              const pct = Math.round(
                ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
              );
              percentEl.textContent = `- ${pct}%`;
            }
          }
          return;
        }

        /* Nothing validated: fall back to the single regular row. If a discount
           paint is still in flight, regios-dopp-sync.js re-asserts the sale
           layout from its cache once DOPP answers, so hiding here is safe —
           and strictly better than leaving an unvalidated price on screen. */
        priceRoot.classList.remove('price--on-sale');
        if (container) {
          container.classList.remove('regios-dopp-generic-price--on-sale', 'price--on-sale');
        }
        saleBlock?.style.setProperty('display', 'none', 'important');
        regularBlock?.style.setProperty('display', 'block', 'important');
        if (compareEl) compareEl.textContent = '';
        if (percentEl) percentEl.textContent = '';
        if (regularPriceEl && formattedPrice) regularPriceEl.textContent = formattedPrice;
        return;
      }

      priceRoot.classList.remove('price--sold-out');

      if (onSale || regiosDiscountActive) {
        // Reject fake Regios "discounts" that paint the same amount into both
        // hooks — that produced two identical prices (struck + bold) on PDP/sticky.
        if (regiosDiscountActive && !onSale) {
          const salePriceEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--sale');
          const compareEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--regular');
          const saleText = salePriceEl?.textContent?.trim();
          const compareText = compareEl?.textContent?.trim();
          if (!saleText || !compareText || saleText === compareText) {
            priceRoot.classList.remove('price--on-sale');
            container?.classList.remove('regios-dopp-generic-price--on-sale');
            saleBlock?.style.setProperty('display', 'none', 'important');
            regularBlock?.style.setProperty('display', 'block', 'important');
            if (compareEl) compareEl.textContent = '';
            const percentEl = saleBlock?.querySelector('.regios-dopp-generic-percent');
            if (percentEl) percentEl.textContent = '';
            if (formattedPrice && regularPriceEl) regularPriceEl.textContent = formattedPrice;
            return;
          }
        }

        priceRoot.classList.add('price--on-sale');
        saleBlock?.style.removeProperty('display');
        regularBlock?.style.removeProperty('display');
        if (onSale) {
          const salePriceEl = saleBlock?.querySelector('.price-item--sale');
          const compareEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--regular');
          if (formattedPrice && salePriceEl) salePriceEl.textContent = formattedPrice;
          const formattedCompare = formatVariantMoney(variant.compare_at_price);
          if (formattedCompare && compareEl) compareEl.textContent = formattedCompare;
        }
        return;
      }

      priceRoot.classList.remove('price--on-sale');
      container?.classList.remove('regios-dopp-generic-price--on-sale');
      saleBlock?.style.setProperty('display', 'none', 'important');
      regularBlock?.style.setProperty('display', 'block', 'important');
      const compareEl = saleBlock?.querySelector('.regios-dopp-generic-price-item--regular');
      // Embed often stamps a zero amount into the empty compare hook on
      // non-discounted PDPs — blank it so it cannot leak if sale shows.
      if (compareEl && isZeroMoney(compareEl.textContent)) compareEl.textContent = '';
      const percentEl = saleBlock?.querySelector('.regios-dopp-generic-percent');
      if (percentEl) percentEl.textContent = '';
      if (formattedPrice && regularPriceEl) regularPriceEl.textContent = formattedPrice;
    });
  }

  /**
   * Re-assert available (non-sold-out) price layout after the Regios embed
   * asynchronously stamps inline display on .price__sale when the URL changes.
   */
  scheduleAvailablePriceSync(sectionId) {
    const variant = this.currentVariant;
    if (!variant?.available || sectionId == null) return;

    this._availablePriceGen ??= new Map();
    const gen = (this._availablePriceGen.get(sectionId) || 0) + 1;
    this._availablePriceGen.set(sectionId, gen);

    const run = () => {
      if (this._availablePriceGen.get(sectionId) !== gen) return;
      if (!this.currentVariant?.available) return;
      this.syncPriceWithVariant(sectionId);
    };

    run();
    requestAnimationFrame(run);
    [50, 150, 300, 500, 800].forEach((delay) => {
      window.setTimeout(run, delay);
    });
  }

  /**
   * Re-assert sold-out single-price layout after the Regios embed asynchronously
   * stamps on-sale classes / inline display on .price__sale.
   */
  scheduleSoldOutPriceSync(sectionId) {
    const variant = this.currentVariant;
    if (!variant || variant.available || sectionId == null) return;

    this._soldOutPriceGen ??= new Map();
    const gen = (this._soldOutPriceGen.get(sectionId) || 0) + 1;
    this._soldOutPriceGen.set(sectionId, gen);

    const run = () => {
      if (this._soldOutPriceGen.get(sectionId) !== gen) return;
      if (this.currentVariant?.available) return;
      this.syncPriceWithVariant(sectionId);
    };

    run();
    requestAnimationFrame(run);
    [50, 150, 300, 500, 800, 1200, 2000, 3500, 5000].forEach((delay) => {
      window.setTimeout(run, delay);
    });
  }
  

  toggleAddButton(soldOut = true) {
    const productFormEl = document.querySelector(
      `product-form.product-form[data-section-id="${this.dataset.section}"]:not(.sticky-atc)`
    );
    if (!productFormEl) return;

    const addButton = productFormEl.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
    const addButtonText = addButton?.querySelector('.product-form__submit-label');
    const opener = addButton?.closest('modal-opener');
    if (!addButton) return;

    this.setSubmitButtonWaitlistMode(addButton, addButtonText, opener, soldOut);
  }

  toggleStickyAddButton(soldOut = true) {
    const stickyProductForm = document.getElementById(`sticky-atc-${this.dataset.section}`);
    if (!stickyProductForm) return;
    const stickyAddButton = stickyProductForm.querySelector(`#StickyProductSubmitButton-${this.dataset.section}`);
    if (!stickyAddButton) return;
    const stickyAddButtonText = stickyAddButton.querySelector('.product-form__submit-label');
    const opener = stickyAddButton.closest('modal-opener');

    this.setSubmitButtonWaitlistMode(stickyAddButton, stickyAddButtonText, opener, soldOut);
  }
  
  updateStickyPrice(sectionId, html) {
    const stickyPriceSourceId = `price-${sectionId}-sticky`;
    const stickyPriceDestinationId = `price-${sectionId}-sticky`;
    
    const source = html.getElementById(stickyPriceSourceId);
    const destination = document.getElementById(stickyPriceDestinationId);
  
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
    }
    const price = document.getElementById(`price-${sectionId}-sticky`);
    if (price) {
      price.classList.remove('hidden');
    }
  }
  updateStickyImage(sectionId, html) {
    const sourceImage = html.getElementById(`image-${sectionId}-sticky`);
    const destinationImage = document.getElementById(`image-${sectionId}-sticky`);

    if (sourceImage && destinationImage) {
      /* AAS-5490: the thumb can ship inside a <picture> whose quality
         <source>s outrank the img's src/srcset — copying attributes alone
         would leave >=2dppx screens frozen on the previous variant. Swap the
         whole picture from the fetched section so the new variant keeps its
         own sources. */
      const sourcePicture = sourceImage.closest('picture');
      const destinationPicture = destinationImage.closest('picture');
      if (sourcePicture && destinationPicture) {
        destinationPicture.replaceWith(sourcePicture);
      } else {
        if (destinationPicture) {
          destinationPicture.querySelectorAll('source').forEach((s) => s.remove());
        }
        destinationImage.src = sourceImage.src;
        destinationImage.srcset = sourceImage.srcset;
        destinationImage.sizes = sourceImage.sizes;
      }
    }
  }

  setUnavailable() {
    const addButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    const addButtonText = addButton?.querySelector('.product-form__submit-label');
    const buttonSticky = document.getElementById(`sticky-atc-${this.dataset.section}`);
    const addButtonSticky = buttonSticky?.querySelector(`#StickyProductSubmitButton-${this.dataset.section}`);
    const addButtonTextSticky = addButtonSticky?.querySelector('.product-form__submit-label');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`price-${this.dataset.section}-sticky`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (addButton && addButtonText) {
      addButton.type = 'button';
      addButton.removeAttribute('name');
      addButton.setAttribute('disabled', 'disabled');
      addButton.removeAttribute('data-sold-out');
      addButton.removeAttribute('data-waitlist');
      addButton.removeAttribute('aria-haspopup');
      addButton.classList.remove('product-form__submit--waitlist');
      addButtonText.textContent = window.variantStrings.unavailable;
      const opener = addButton.closest('modal-opener');
      if (opener) {
        opener.classList.remove('product-form__submit-opener--waitlist');
        opener.removeAttribute('data-modal');
      }
    }
    if (addButtonSticky && addButtonTextSticky) {
      addButtonSticky.type = 'button';
      addButtonSticky.removeAttribute('name');
      addButtonSticky.setAttribute('disabled', 'disabled');
      addButtonSticky.removeAttribute('data-sold-out');
      addButtonSticky.removeAttribute('data-waitlist');
      addButtonSticky.removeAttribute('aria-haspopup');
      addButtonSticky.classList.remove('product-form__submit--waitlist');
      addButtonTextSticky.textContent = window.variantStrings.unavailable;
      const stickyOpener = addButtonSticky.closest('modal-opener');
      if (stickyOpener) {
        stickyOpener.classList.remove('product-form__submit-opener--waitlist');
        stickyOpener.removeAttribute('data-modal');
      }
    }
    if (price) price.classList.add('hidden');
    if (priceSticky) priceSticky.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    const productHeaderSkuIds = [
      `ProductHeader-Sku-${this.dataset.section}`,
      `ProductHeader-Sku-Mobile-${this.dataset.section}`,
    ];
    productHeaderSkuIds.forEach((id) => {
      const productHeaderSku = document.getElementById(id);
      if (productHeaderSku) productHeaderSku.classList.add('visibility-hidden');
    });
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Select a variant by id (dimensions column click, AAS-5383).
   * Applies every option on that variant, then dispatches one native bubbling
   * `change` from the last changed radio/select so the existing picker
   * pipeline runs — including the sticky CTA size chip, which only listens
   * for change on INPUT/SELECT inside #MainProduct-*. Does not move focus
   * (the shopper is on the dimensions table, not the picker).
   * @returns {boolean} true if a change was dispatched
   */
  selectVariantById(variantId) {
    try {
      const variant = this.getVariantData().find(({ id }) => String(id) === String(variantId));
      if (!variant) return false;
      if (this.currentVariant != null && String(this.currentVariant.id) === String(variantId)) {
        return true;
      }

      const optionElements = [...this.querySelectorAll('select, fieldset')];
      let changeTarget = null;

      optionElements.forEach((element, index) => {
        const value = variant.options[index];
        if (value == null) return;

        if (element.tagName === 'SELECT') {
          const hasOption = [...element.options].some((option) => option.value === value);
          if (hasOption && element.value !== value) {
            element.value = value;
            changeTarget = element;
          }
          return;
        }

        const radio = [...element.querySelectorAll('input[type="radio"]')].find(
          ({ value: radioValue }) => radioValue === value
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          changeTarget = radio;
        }
      });

      if (!changeTarget) return false;
      changeTarget.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch {
      return false;
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);



class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

const setScrollbarWidth = () => {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  } else {
    document.documentElement.style.setProperty("--scrollbar-width", "0px");
  }
};
setScrollbarWidth();


class ResponsiveImage extends HTMLElement {
  constructor() {
    super();
    this.handleIntersection = this.handleIntersection.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onResize = this.onResize.bind(this);

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '10px',
      threshold: 0
    });

    this.resizeObserver = new ResizeObserver(this.onResize);
  }

  connectedCallback() {
    this.img = this.querySelector('img');
    if (this.img) {
      this.img.addEventListener('load', this.onImageLoad);
      this.img.classList.add('img-loading');

      if (this.img.hasAttribute('srcset')) {
        this.originalSrcset = this.img.getAttribute('srcset');
        this.img.removeAttribute('srcset');
        this.intersectionObserver.observe(this.img);
      }
    }
  }

  disconnectedCallback() {
    if (this.img) {
      this.img.removeEventListener('load', this.onImageLoad);
      this.intersectionObserver.unobserve(this.img);
      this.resizeObserver.unobserve(this.img);
      this.intersectionObserver.disconnect();
      this.resizeObserver.disconnect();
    }
  }

  onImageLoad() {
    this.img.classList.remove('img-loading');
    this.img.classList.add('img-loaded');
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;

        if (this.hasAttribute('data-sizes') && this.getAttribute('data-sizes') === "true") {
          this.updateSizes(img);
          this.resizeObserver.observe(img);
        }

        img.setAttribute('srcset', this.originalSrcset);
        this.intersectionObserver.unobserve(img);
      }
    });
  }

  onResize(entries) {
    entries.forEach(entry => {
      if (this.hasAttribute('data-sizes') && this.getAttribute('data-sizes') === "true") {
        this.updateSizes(entry.target);
      }
    });
  }

  updateSizes(img) {
    const width = Math.floor(img.getBoundingClientRect().width);
    img.setAttribute('sizes', `${width}px`);
  }
}

customElements.define('responsive-image', ResponsiveImage);


/**
 *  @class
 *  @function ViewportMedia
 */

if (!customElements.get('viewport-media')) {
  class ViewportMedia extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this._onDocMouseMove = (e) => this.onProgressDrag(e);
      this._onDocTouchMove = (e) => this.onProgressDrag(e);
      this._onDocMouseUp = () => this.endProgressDrag();
      this._onDocTouchEnd = () => this.endProgressDrag();
      this.initObserver();
    }

    disconnectedCallback() {
      // Safety net: if removed mid-drag (e.g. theme-editor section reload),
      // ensure the transient document listeners are torn down.
      this.endProgressDrag();
    }

    initObserver() {
      if (this.dataset.isYoutube === 'true') {
        this.initYouTube();
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadContent();
              this.observer.unobserve(entry.target);
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px 0px 200px 0px'
        });

        this.observer.observe(this);
      } else {
        this.loadContent();
      }
    }

    loadContent() {
      if (!this.getAttribute('loaded')) {
        const template = this.querySelector('template');
        if (template && template.content && template.content.firstElementChild) {
          const content = document.createElement('div');
          content.appendChild(template.content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, iframe'));

          if (deferredElement.nodeName === 'IFRAME') {
            const src = deferredElement.getAttribute('data-src');
            if (src) {
              deferredElement.setAttribute('src', src);
            }
            deferredElement.onload = () => this.removePlaceholder();
          }
          if (deferredElement.nodeName === 'VIDEO') {
            // Every video in the theme starts at half volume once it is
            // unmuted — full blast is a jump-scare on a product page, and the
            // browser's default of 1 is what these native controls would
            // otherwise inherit. Matches armada-video.js's DEFAULT_VOLUME.
            deferredElement.volume = 0.5;
            const isAutoplay = deferredElement.getAttribute('autoplay');
            const poster = deferredElement.getAttribute('poster');
            if (!isAutoplay && poster) {
              deferredElement.setAttribute('poster', poster);
            }
            deferredElement.onloadeddata = () => {
              this.removePlaceholder();
              if (isAutoplay) {
                deferredElement.muted = true;
                deferredElement.play().catch(error => {
                  console.warn('Autoplay failed:', error);
                });
              }
              this.initVideoControls(deferredElement);
              this.playIfActiveShopableVideo(deferredElement);
            };
            deferredElement.load();
          }
        }
      }
    }

    initYouTube() {
      if (this.youtubeInitialized) return;
      this.youtubeInitialized = true;
      this.youtubeTarget = this.querySelector('[data-youtube-target]');
      this.youtubeUrl = this.dataset.youtubeUrl;
      const playButton = this.querySelector('.shopable-video__youtube-play');
      if (playButton) {
        playButton.addEventListener('click', () => this.playYouTube());
      }
    }

    playYouTube() {
      const videoId = this.parseYouTubeId(this.youtubeUrl);
      if (!videoId || !this.youtubeTarget) return;
      if (this.youtubeTarget.querySelector('iframe')) return;

      const playButton = this.querySelector('.shopable-video__youtube-play');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'YouTube video';

      this.youtubeTarget.appendChild(iframe);
      this.classList.add('is-playing');
      if (playButton) {
        playButton.hidden = true;
        playButton.setAttribute('aria-hidden', 'true');
      }
    }

    resetYouTube() {
      if (this.dataset.isYoutube !== 'true') return;
      const target = this.querySelector('[data-youtube-target]');
      if (target) target.innerHTML = '';
      this.classList.remove('is-playing');
      const playButton = this.querySelector('.shopable-video__youtube-play');
      if (playButton) {
        playButton.hidden = false;
        playButton.removeAttribute('aria-hidden');
      }
    }

    parseYouTubeId(url) {
      if (!url) return null;
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
        /^([a-zA-Z0-9_-]{11})$/
      ];
      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) return match[1];
      }
      return null;
    }

    initVideoControls(video) {
      const playPauseButton = this.querySelector('.armada-video__controls-playpause') || this.querySelector('.video-play-pause');
      const muteToggleButton = this.querySelector('.video-mute-toggle');
      const progressContainer = this.querySelector('.armada-video__progress-container');
      const progressFilled = this.querySelector('.armada-video__progress-fill') || this.querySelector('.video-progress-filled');
      const iconPause = this.querySelector('.armada-video__icon-pause');
      const iconPlay = this.querySelector('.armada-video__icon-play');

      const setPlaying = (playing) => {
        if (playPauseButton && iconPause && iconPlay) {
          iconPause.classList.toggle('hidden', !playing);
          iconPlay.classList.toggle('hidden', playing);
        } else if (playPauseButton) {
          playPauseButton.classList.toggle('is-pause', playing);
          playPauseButton.classList.toggle('is-play', !playing);
        }
      };

      if (playPauseButton) {
        playPauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            setPlaying(true);
          } else {
            video.pause();
            setPlaying(false);
          }
        });

        video.addEventListener('ended', () => {
          setPlaying(false);
          if (progressFilled) progressFilled.style.width = '0%';
          if (progressContainer) progressContainer.setAttribute('aria-valuenow', '0');
        });

        video.addEventListener('play', () => setPlaying(true));
        video.addEventListener('pause', () => setPlaying(false));
        setPlaying(!video.paused);
      }

      if (muteToggleButton) {
        muteToggleButton.addEventListener('click', () => {
          video.muted = !video.muted;
          muteToggleButton.classList.toggle('is-muted', video.muted);
          muteToggleButton.classList.toggle('is-unmuted', !video.muted);
        });
      }

      if (progressFilled && progressContainer) {
        const updateProgress = () => {
          if (!video.duration || this.isDragging) return;
          const pct = (video.currentTime / video.duration) * 100;
          progressFilled.style.width = `${pct}%`;
          progressContainer.setAttribute('aria-valuenow', Math.round(pct));
        };

        video.addEventListener('timeupdate', updateProgress);

        progressContainer.addEventListener('click', (e) => this.seekVideo(video, e));
        progressContainer.addEventListener('mousedown', (e) => this.startProgressDrag(video, e));
        progressContainer.addEventListener('touchstart', (e) => this.startProgressDrag(video, e), { passive: false });
        progressContainer.addEventListener('keydown', (e) => this.onProgressKeydown(video, e));

        video.addEventListener('canplay', () => {
          if (!video.paused) updateProgress();
        });
      } else if (progressFilled) {
        const progressBar = this.querySelector('.video-progress-bar');

        const updateProgressBar = () => {
          const percentage = (video.currentTime / video.duration) * 100 || 0;
          progressFilled.style.width = `${percentage}%`;
          if (progressBar) {
            progressBar.setAttribute('aria-valuenow', Math.round(percentage));
          }
        };

        if (progressBar) {
          progressBar.addEventListener('click', (e) => {
            if (!video.duration) return;
            const rect = progressBar.getBoundingClientRect();
            const pos = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
            video.currentTime = pos * video.duration;
          });

          progressBar.addEventListener('keydown', (e) => this.onProgressKeydown(video, e));
        }

        video.addEventListener('timeupdate', updateProgressBar);
        video.addEventListener('ended', () => {
          progressFilled.style.width = '0%';
        });
        video.addEventListener('canplay', () => {
          if (!video.paused) updateProgressBar();
        });
      }
    }

    getProgressPosition(e) {
      const progressContainer = this.querySelector('.armada-video__progress-container');
      if (!progressContainer) return 0;
      const rect = progressContainer.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    }

    seekVideo(video, e) {
      if (this.isDragging || !video.duration) return;
      video.currentTime = this.getProgressPosition(e) * video.duration;
    }

    startProgressDrag(video, e) {
      if (!video.duration) return;
      this.isDragging = true;
      this.dragVideo = video;
      // Listen on document only for the duration of the drag, so a pointer that
      // leaves the progress bar still tracks. Removed in endProgressDrag to avoid
      // leaking global listeners per video element.
      document.addEventListener('mousemove', this._onDocMouseMove);
      document.addEventListener('touchmove', this._onDocTouchMove, { passive: false });
      document.addEventListener('mouseup', this._onDocMouseUp);
      document.addEventListener('touchend', this._onDocTouchEnd);
      this.onProgressDrag(e);
    }

    onProgressDrag(e) {
      const video = this.dragVideo;
      if (!this.isDragging || !video?.duration) return;
      e.preventDefault();
      const pos = this.getProgressPosition(e);
      const progressFilled = this.querySelector('.armada-video__progress-fill');
      const progressContainer = this.querySelector('.armada-video__progress-container');
      if (progressFilled) progressFilled.style.width = `${pos * 100}%`;
      if (progressContainer) progressContainer.setAttribute('aria-valuenow', Math.round(pos * 100));
      video.currentTime = pos * video.duration;
    }

    endProgressDrag() {
      this.isDragging = false;
      this.dragVideo = null;
      document.removeEventListener('mousemove', this._onDocMouseMove);
      document.removeEventListener('touchmove', this._onDocTouchMove);
      document.removeEventListener('mouseup', this._onDocMouseUp);
      document.removeEventListener('touchend', this._onDocTouchEnd);
    }

    onProgressKeydown(video, e) {
      if (!video.duration) return;
      const step = 5;

      switch (e.key) {
        case 'ArrowRight':
          e.preventDefault();
          video.currentTime = Math.min(video.duration, video.currentTime + step);
          break;
        case 'ArrowLeft':
          e.preventDefault();
          video.currentTime = Math.max(0, video.currentTime - step);
          break;
      }
    }

    removePlaceholder() {
      const placeholder = this.querySelector('.video-placeholder');
      if (placeholder) {
        placeholder.style.display = 'none';
      }
    }

    playIfActiveShopableVideo(video) {
      const carousel = this.closest('splide-carousel.shopable-video-carousel');
      const slide = this.closest('.splide__slide');
      if (!carousel || !slide?.classList.contains('is-active')) return;
      if (carousel.getAttribute('data-play-videos') === 'true') return;

      video.muted = true;
      if (video.paused) {
        video.play().catch((error) => {
          console.warn('Autoplay failed:', error);
        });
      }
    }
  }

  customElements.define('viewport-media', ViewportMedia);
}

/**
 *  @function
 *  @function enableTrackpadScroll
 */

function isHorizontalWheelIntent(event) {
  const absX = Math.abs(event.deltaX);
  const absY = Math.abs(event.deltaY);
  return absX > absY && absX > 10;
}

function enableTrackpadScroll(splideInstance, trackElement, options = {}) {
  if (!trackElement || !splideInstance) return null;
  if (splideInstance.root && !splideInstance.root.classList.contains('is-active')) return null;

  const perPage = splideInstance.options.perPage || 1;
  let handleWheel;

  if (perPage === 1) {
    let lastWheel = 0;
    const lockTime = options.throttle || 800;

    handleWheel = (e) => {
      if (!isHorizontalWheelIntent(e)) return;
      e.preventDefault();

      const now = Date.now();
      if (now - lastWheel < lockTime) return;
      lastWheel = now;

      if (e.deltaX > 0) splideInstance.go('>');
      else if (e.deltaX < 0) splideInstance.go('<');
    };
  } else {
    let accumulated = 0;
    const threshold = options.threshold || 40;

    handleWheel = (e) => {
      if (!isHorizontalWheelIntent(e)) return;
      e.preventDefault();

      accumulated += e.deltaX;

      if (Math.abs(accumulated) > threshold) {
        if (accumulated > 0) splideInstance.go('>');
        else splideInstance.go('<');
        accumulated = 0;
      }
    };
  }

  trackElement.addEventListener('wheel', handleWheel, { passive: false });

  return () => {
    trackElement.removeEventListener('wheel', handleWheel);
  };
}

/**
 *  @function
 *  @function initializeProgressBar
 */
function initializeProgressBar(splideInstance, barElement) {
  if (!barElement || !splideInstance) return null;

  let progressRafId = null;

  const update = () => {
    if (!splideInstance) return;
    if (progressRafId) cancelAnimationFrame(progressRafId);

    progressRafId = requestAnimationFrame(() => {
      if (!splideInstance) return;
      const end = splideInstance.Components.Controller.getEnd() + 1;
      const rate = Math.min((splideInstance.index + 1) / end, 1);
      barElement.style.setProperty('--scale-x', rate);
      progressRafId = null;
    });
  };

  update();
  splideInstance.on('move', update);

  // Return cleanup function
  return () => {
    if (progressRafId) cancelAnimationFrame(progressRafId);
    if (splideInstance) splideInstance.off('move', update);
  };
}

function initializePdpSwipeIndicator(splideInstance, progressContainer, indicatorBar, hostElement) {
  if (!splideInstance || !progressContainer || !indicatorBar) return null;

  let updateRafId = null;

  const getTrackElement = () =>
    splideInstance.root?.querySelector('.splide__track') ||
    hostElement?.querySelector('.main-carousel .splide__track');

  const getActiveSlide = () => {
    const slides = splideInstance.Components?.Elements?.slides || [];
    return slides[splideInstance.index] || slides.find((slide) => slide.classList.contains('is-active'));
  };

  const update = () => {
    if (!splideInstance) return;
    if (updateRafId) cancelAnimationFrame(updateRafId);

    updateRafId = requestAnimationFrame(() => {
      const totalCount = splideInstance.length;

      if (totalCount <= 1) {
        progressContainer.style.display = 'none';
        indicatorBar.style.width = '0px';
        indicatorBar.style.transform = 'translateX(0px)';
        updateRafId = null;
        return;
      }

      const activeSlide = getActiveSlide();
      const trackElement = getTrackElement();

      if (!activeSlide || !trackElement) {
        updateRafId = null;
        return;
      }

      // Progress bar spans the full carousel track width (full-bleed on mobile),
      // not the active slide. Contain-mode slides shrink-wrap the image
      // (autoWidth), which made the bar take the image's width + centering
      // offset — narrow and shifted. Divide the indicator across the full width.
      const trackRect = trackElement.getBoundingClientRect();
      const trackWidth = trackRect.width;

      if (!trackWidth) {
        updateRafId = null;
        return;
      }

      const segmentWidth = trackWidth / totalCount;
      const currentIndex = Math.min(Math.max(splideInstance.index, 0), totalCount - 1);
      const translateX = segmentWidth * currentIndex;

      progressContainer.style.display = '';
      progressContainer.style.insetInlineStart = '0px';
      progressContainer.style.left = '0px';
      progressContainer.style.right = 'auto';
      progressContainer.style.transform = 'none';
      progressContainer.style.width = `${trackWidth}px`;
      indicatorBar.style.width = `${segmentWidth}px`;
      indicatorBar.style.transform = `translateX(${translateX}px)`;
      updateRafId = null;
    });
  };

  update();

  splideInstance.on('mounted moved resized updated refresh scroll', update);
  window.addEventListener('resize', update);

  return () => {
    if (updateRafId) cancelAnimationFrame(updateRafId);
    if (splideInstance) {
      splideInstance.off('mounted moved resized updated refresh scroll', update);
    }
    window.removeEventListener('resize', update);
  };
}

/**
 *  @class
 *  @function SplideCarousel
 */


class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    this.slideInstance = null;
    this.observer = null;
    this.isInViewport = false;
    this.timeouts = [];
    this.progressBarCleanup = null;
    this.boundHandlers = {};
    this.trackpadCleanup = null;
  }

  connectedCallback() {
    if (!this.slideInstance) this.initializeSplide();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  initializeSplide() {
    const splideEl = this.querySelector('.splide');
    const options = splideEl?.getAttribute('data-splide');
    if (!options) return;
    
    try {
      const parsedOptions = JSON.parse(options);
      this.slideInstance = new Splide(splideEl, parsedOptions);
      
      this.slideInstance.on('mounted', () => {
        if (window.ShopableVideo?.isShopableCarousel?.(this)) {
          window.ShopableVideo.bindCarousel?.(this, this.slideInstance);
          window.ShopableVideo.handleVideoPlayback(this, this.slideInstance, this.isInViewport, this.observer);
        }
      });
      
      this.slideInstance.on('moved', () => {
        if (window.ShopableVideo?.isShopableCarousel?.(this)) {
          window.ShopableVideo.onMoved(this, this.slideInstance, this.isInViewport, this.observer);
        }
      });
      
      const videoTimeout = setTimeout(() => {
        if (this.slideInstance && window.ShopableVideo?.isShopableCarousel?.(this)) {
          window.ShopableVideo.bindCarousel?.(this, this.slideInstance);
          window.ShopableVideo.handleVideoPlayback(this, this.slideInstance, this.isInViewport, this.observer);
        }
      }, 100);
      this.timeouts.push(videoTimeout);
      
      const progressTimeout = setTimeout(() => {
        if (this.slideInstance) {
          const bar = this.querySelector('.splide-carousel-progress-bar');
          this.progressBarCleanup = initializeProgressBar(this.slideInstance, bar);
        }
      }, 300);
      this.timeouts.push(progressTimeout);
      
      this.fixFadeRtlBug();
      this.slideInstance.mount();
      
      const track = this.querySelector('.splide__track');
      this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track);
      
    } catch (e) {
      console.error('Failed to initialize Splide carousel:', e);
    }
    
    this.initObserver();
    
    if (Shopify.designMode) {
      this.addShopifyEventListeners();
    }
  }

  initObserver() {
    if (!('IntersectionObserver' in window)) {
      this.isInViewport = true;
      return;
    }
    
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const wasInViewport = this.isInViewport;
        this.isInViewport = entry.isIntersecting;
        
        if (window.ShopableVideo?.isShopableCarousel?.(this)) {
          if (this.isInViewport && !wasInViewport) {
            window.ShopableVideo.handleVideoPlayback(this, this.slideInstance, true, null);
          } else if (!this.isInViewport && wasInViewport) {
            window.ShopableVideo.pauseAllVideos(this, this.slideInstance);
          }
        }
      });
    }, { rootMargin: '0px 0px -50% 0px', threshold: 0.1 });
    
    this.observer.observe(this);

    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      this.isInViewport = true;
    }
  }

  addShopifyEventListeners() {
    this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
    document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
  }

  removeShopifyEventListeners() {
    if (this.boundHandlers.blockSelect) {
      document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
    }
  }

  handleBlockSelect(e) {
    const carousel = e.target.closest('splide-carousel');
    if (carousel === this && this.slideInstance) {
      const index = parseInt(e.target.getAttribute('data-splide-index'));
      if (!isNaN(index)) {
        this.slideInstance.go(index);
        this.slideInstance.Components.Autoplay?.pause();
      }
    }
  }


  fixFadeRtlBug() {
    if (this.getAttribute('data-fix-fade-rtl') !== 'true') return;
    if (document.documentElement.getAttribute('dir') !== 'rtl') return;
    
    this.slideInstance.on('ready', () => {
      this.querySelectorAll('.splide__slide').forEach(slide => {
        const transform = slide.style.transform;
        if (transform?.includes('-')) {
          slide.style.transform = transform.replace(/-/g, '');
        }
      });
    });
  }

  cleanup() {
    this.timeouts.forEach(t => clearTimeout(t));
    this.timeouts = [];
    
    if (this.progressBarCleanup) {
      this.progressBarCleanup();
      this.progressBarCleanup = null;
    }

    if (window.ShopableVideo?.isShopableCarousel?.(this)) {
      window.ShopableVideo.pauseAllVideos(this, this.slideInstance);
      window.ShopableVideo.cleanup(this);
    }
    
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.trackpadCleanup) {
      this.trackpadCleanup();
      this.trackpadCleanup = null;
    }
    
    if (Shopify.designMode) this.removeShopifyEventListeners();
    
    if (this.slideInstance) {
      this.slideInstance.destroy();
      this.slideInstance = null;
    }
    
    this.isInViewport = false;
    this.boundHandlers = {};
    this.trackpadScrollElement = null;
  }
}

customElements.define('splide-carousel', SplideCarousel);


/**
 *  @class
 *  @function Slideshow
 */

if (!customElements.get('slide-show')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.observer = null;
      this.isInViewport = false;
      this.isUserInteracting = false;
      this.movingCursor = null;
      this.isMouseOverSlideshow = false;
      this.cursorUpdateRAF = null;
      this.lastMouseEvent = null;
      this.boundHandlers = {};
      this.trackpadCleanup = null;
    }

    connectedCallback() {
      this.init();
      this.initializeMovingCursor();
      this.initObserver();
      
      if (Shopify?.designMode) {
        this.addShopifyEventListeners();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      const options = this.getAttribute('data-splide');
      if (!options) return;

      try {
        this.slideInstance = new Splide(this, JSON.parse(options));

        if (this.getAttribute('data-pagination') === 'numbers') {
          this.slideInstance.on('pagination:mounted', this.customizePagination);
        }

        this.slideInstance.on('moved', (newIndex) => {
          this.handleVideoPlayback();
          this.updateSlideCounter(newIndex);
          this.handleFirstSlide();
        });

        this.fixFadeRtlBug();
        this.slideInstance.mount();
        this.updateSlideCounter(this.slideInstance.index);
        
        const track = this.querySelector('.splide__track');
        if (track && typeof enableTrackpadScroll === 'function') {
          this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track, { throttle: 800 });
        }

      } catch (e) {
        console.error('Failed to initialize Slideshow:', e);
      }
    }

    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.isInViewport = true;
        return;
      }

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const wasInViewport = this.isInViewport;
          this.isInViewport = entry.isIntersecting;

          if (this.isInViewport && !wasInViewport) {
            this.handleVideoPlayback();
          } else if (!this.isInViewport && wasInViewport) {
            this.pauseAllVideos();
          }
        });
      }, { rootMargin: '0px 0px -50% 0px', threshold: 0.1 });

      this.observer.observe(this);
    }

    handleFirstSlide() {
      this.slideInstance.Components.Elements.slides.forEach(slide => {
        slide.classList.remove('first-slide');
      });
    }

    fixFadeRtlBug() {
      if (document.documentElement.getAttribute('dir') !== 'rtl') return;

      this.slideInstance.on('ready', () => {
        this.querySelectorAll('.splide__slide').forEach(slide => {
          const transform = slide.style.transform;
          if (transform?.includes('-')) {
            slide.style.transform = transform.replace(/-/g, '');
          }
        });
      });
    }

    handleVideoPlayback() {
      if (!this.slideInstance || (!this.isInViewport && this.observer)) return;

      this.slideInstance.Components.Elements.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          if (slide.classList.contains('is-active')) {
            video.paused && video.play().catch(e => console.error('Error playing video:', e));
          } else {
            !video.paused && video.pause();
          }
        }
      });
    }

    pauseAllVideos() {
      if (!this.slideInstance) return;

      this.slideInstance.Components.Elements.slides.forEach(slide => {
        const video = slide.querySelector('video');
        video && !video.paused && video.pause();
      });
    }

    updateSlideCounter(newIndex) {
      const currentSlideEl = this.querySelector('.current-slide');
      const totalSlidesEl = this.querySelector('.total-slides');
      const slideCounter = this.querySelector('.slide-counter');

      if (currentSlideEl && totalSlidesEl) {
        if (slideCounter) {
          slideCounter.classList.remove('slide-counter-progress');
          void slideCounter.offsetWidth;
        }

        totalSlidesEl.textContent = this.slideInstance.length;
        currentSlideEl.textContent = newIndex + 1;

        if (slideCounter) {
          slideCounter.classList.add('slide-counter-progress');
        }
      }
    }

    customizePagination(data) {
      data.list.classList.add('splide__pagination--custom');
      data.items.forEach(item => {
        item.button.textContent = String(item.page + 1).padStart(2, '0');
      });
    }

    initializeMovingCursor() {
      this.movingCursor = this.querySelector('.slideshow__moving-cursor');
      if (!this.movingCursor) return;

      this.boundHandlers = {
        mouseenter: this.handleMouseEnterSlideshow.bind(this),
        mouseleave: this.handleMouseLeaveSlideshow.bind(this),
        mousemove: this.handleMouseMoveOnSlideshow.bind(this),
        click: this.handleClickOnSlideshow.bind(this)
      };

      this.addEventListener('mouseenter', this.boundHandlers.mouseenter);
      this.addEventListener('mouseleave', this.boundHandlers.mouseleave);
      this.addEventListener('mousemove', this.boundHandlers.mousemove, { passive: true });
      this.addEventListener('click', this.boundHandlers.click);
    }

    isInteractiveElement(target) {
      return target?.closest?.('.slideshow-interactive-element, .splide__pagination, .splide__arrow');
    }

    handleMouseEnterSlideshow(event) {
      if (!this.movingCursor || (this.slideInstance && this.slideInstance.length <= 1)) return;
      
      this.isMouseOverSlideshow = true;
      this.lastMouseEvent = event;

      if (this.isInteractiveElement(event.target)) {
        this.hideCursor();
      } else {
        this.showCursor();
        this.updateMovingCursorState();
      }
    }

    handleMouseLeaveSlideshow() {
      this.isMouseOverSlideshow = false;
      this.lastMouseEvent = null;
      this.hideCursor();
      
      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
        this.cursorUpdateRAF = null;
      }
    }

    handleMouseMoveOnSlideshow(event) {
      this.lastMouseEvent = event;

      if (!this.isMouseOverSlideshow || !this.movingCursor || 
          !this.slideInstance || this.slideInstance.length <= 1) {
        this.hideCursor();
        return;
      }

      if (this.isInteractiveElement(event.target)) {
        this.hideCursor();
        if (this.cursorUpdateRAF) {
          cancelAnimationFrame(this.cursorUpdateRAF);
          this.cursorUpdateRAF = null;
        }
        return;
      }

      if (!this.movingCursor.classList.contains('visible')) {
        this.showCursor();
      }

      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
      }
      
      this.cursorUpdateRAF = requestAnimationFrame(() => {
        this.updateMovingCursorState();
        this.cursorUpdateRAF = null;
      });
    }

    updateMovingCursorState() {
      if (!this.movingCursor || !this.isMouseOverSlideshow || !this.lastMouseEvent) return;

      const event = this.lastMouseEvent;
      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      this.movingCursor.style.transform = `translate(${x}px, ${y}px)`;

      if (x < rect.width / 2) {
        this.movingCursor.classList.add('prev-style');
        this.movingCursor.classList.remove('next-style');
      } else {
        this.movingCursor.classList.add('next-style');
        this.movingCursor.classList.remove('prev-style');
      }
    }

    showCursor() {
      if (!this.movingCursor) return;
      this.movingCursor.classList.add('visible');
      this.classList.add('cursor-active');
    }

    hideCursor() {
      if (!this.movingCursor) return;
      this.movingCursor.classList.remove('visible');
      this.classList.remove('cursor-active');
    }

    handleClickOnSlideshow(event) {
      if (this.isInteractiveElement(event.target)) return;
      if (!this.slideInstance || this.slideInstance.length <= 1 || this.isUserInteracting) return;

      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;

      this.slideInstance.go(x < rect.width / 2 ? '<' : '>');
    }

    addShopifyEventListeners() {
      this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
      this.boundHandlers.blockDeselect = this.handleBlockDeselect.bind(this);
      document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      document.addEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
    }

    removeShopifyEventListeners() {
      if (this.boundHandlers.blockSelect) {
        document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      }
      if (this.boundHandlers.blockDeselect) {
        document.removeEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
      }
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const slideEl = event.target.closest('.splide__slide');
      if (this.slideInstance && slideEl && this.contains(slideEl)) {
        const index = parseInt(slideEl.getAttribute('data-splide-index'));
        if (!isNaN(index)) {
          this.slideInstance.go(index);
          this.isUserInteracting = true;
          this.slideInstance.Components.Autoplay?.pause();
        }
      }
    }

    handleBlockDeselect() {
      this.isUserInteracting = false;
    }

    stopCursorAnimation() {
      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
        this.cursorUpdateRAF = null;
      }
    }

    cleanup() {
      this.stopCursorAnimation();

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.pauseAllVideos();

      if (this.movingCursor) {
        this.removeEventListener('mouseenter', this.boundHandlers.mouseenter);
        this.removeEventListener('mouseleave', this.boundHandlers.mouseleave);
        this.removeEventListener('mousemove', this.boundHandlers.mousemove);
        this.removeEventListener('click', this.boundHandlers.click);
      }

      if (Shopify?.designMode) {
        this.removeShopifyEventListeners();
      }

      if (this.slideInstance) {
        this.slideInstance.destroy();
        this.slideInstance = null;
      }

      this.isInViewport = false;
      this.isMouseOverSlideshow = false;
      this.lastMouseEvent = null;
      this.boundHandlers = {};
    }
  }

  customElements.define('slide-show', Slideshow);
}

/**
 *  @class
 *  @function AsyncCarousel
 */

if (!customElements.get('async-carousel')) {
  class AsyncCarousel extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.thumbnailInstance = null;
      this.isUserInteracting = false;
      this.thumbnails = null;
      this.currentThumbnail = null;
      this.trackpadCleanup = null;
      this.progressBarCleanup = null;
      this.rafId = null;
      this.boundHandlers = {};
      this.timeouts = [];
    }

    connectedCallback() {
      this.initCarousel();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initCarousel() {
      const mainSlider = this.querySelector('[data-slider="main"]');
      const thumbnailSlider = this.querySelector('[data-slider="thumbnail"]');

      if (!mainSlider) return;

      try {
        const mainOptions = JSON.parse(mainSlider.getAttribute('data-splide') || '{}');
        this.slideInstance = new Splide(mainSlider, mainOptions);
        
        if (thumbnailSlider) {
          const thumbnailOptions = JSON.parse(thumbnailSlider.getAttribute('data-splide') || '{}');
          this.thumbnailInstance = new Splide(thumbnailSlider, thumbnailOptions);
          this.slideInstance.sync(this.thumbnailInstance);
          this.updateThumbnailARIA(thumbnailSlider);
        }

        this.fixFadeRtlBug();
        this.slideInstance.mount();
        
        if (this.thumbnailInstance) {
          this.thumbnailInstance.mount();
        }

        const track = mainSlider.querySelector('.splide__track');
        this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track, { throttle: 800 });
        
        const progressTimeout = setTimeout(() => {
          if (this.slideInstance) {
            const bar = this.querySelector('.splide-carousel-progress-bar');
            this.progressBarCleanup = initializeProgressBar(this.slideInstance, bar);
          }
        }, 300);
        this.timeouts.push(progressTimeout);

        this.initThumbnails();

        if (Shopify?.designMode) {
          this.addShopifyEventListeners();
        }
      } catch (e) {
        console.error('Failed to initialize AsyncCarousel:', e);
      }
    }

    addShopifyEventListeners() {
      this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
      this.boundHandlers.blockDeselect = this.handleBlockDeselect.bind(this);
      document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      document.addEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
    }

    removeShopifyEventListeners() {
      if (this.boundHandlers.blockSelect) {
        document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      }
      if (this.boundHandlers.blockDeselect) {
        document.removeEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
      }
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const blockElement = event.target;
      const index = parseInt(blockElement.getAttribute('data-splide-index'));

      if (!isNaN(index) && this.slideInstance) {
        this.slideInstance.go(index);
        this.isUserInteracting = true;
        this.slideInstance.Components.Autoplay?.pause();
      }
    }

    handleBlockDeselect(event) {
      if (!this.contains(event.target)) return;
      this.isUserInteracting = false;
    }

    initThumbnails() {
      this.thumbnails = this.querySelectorAll('.thumbnail-item');
      if (!this.thumbnails.length) return;

      this.thumbnails.forEach((thumbnail, index) => {
        const handler = () => this.slideInstance?.go(index);
        thumbnail.addEventListener('click', handler);
        
        if (!this.boundHandlers.thumbnails) {
          this.boundHandlers.thumbnails = [];
        }
        this.boundHandlers.thumbnails.push({ element: thumbnail, handler });
      });

      const updateThumbnail = () => {
        if (this.rafId) cancelAnimationFrame(this.rafId);

        this.rafId = requestAnimationFrame(() => {
          const thumbnail = this.thumbnails[this.slideInstance.index];
          if (thumbnail) {
            if (this.currentThumbnail) {
              this.currentThumbnail.classList.remove('is-active');
            }
            thumbnail.classList.add('is-active');
            this.currentThumbnail = thumbnail;
          }
          this.rafId = null;
        });
      };

      this.slideInstance.on('mounted move', updateThumbnail);

      if (this.thumbnails.length > 0) {
        this.thumbnails[0].classList.add('is-active');
        this.currentThumbnail = this.thumbnails[0];
      }
    }


    fixFadeRtlBug() {
      if (this.getAttribute('data-fix-fade-rtl') !== 'true') return;
      if (document.documentElement.getAttribute('dir') !== 'rtl') return;

      this.slideInstance.on('ready', () => {
        const mainSlider = this.querySelector('[data-slider="main"]');
        if (!mainSlider) return;

        mainSlider.querySelectorAll('.splide__slide').forEach(slide => {
          const transform = slide.style.transform;
          if (transform?.includes('-')) {
            slide.style.transform = transform.replace(/-/g, '');
          }
        });
      });
    }

    updateThumbnailARIA(thumbnailSlider) {
      const thumbnailItems = thumbnailSlider.querySelectorAll('.splide__slide');
      thumbnailItems.forEach(thumbnailItem => {
        thumbnailItem.setAttribute('role', 'group');
      });
    }

    cleanup() {
      this.timeouts.forEach(t => clearTimeout(t));
      this.timeouts = [];

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.progressBarCleanup) {
        this.progressBarCleanup();
        this.progressBarCleanup = null;
      }

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.boundHandlers.thumbnails) {
        this.boundHandlers.thumbnails.forEach(({ element, handler }) => {
          element.removeEventListener('click', handler);
        });
      }

      if (Shopify?.designMode) {
        this.removeShopifyEventListeners();
      }

      if (this.slideInstance) {
        this.slideInstance.destroy();
        this.slideInstance = null;
      }

      if (this.thumbnailInstance) {
        this.thumbnailInstance.destroy();
        this.thumbnailInstance = null;
      }

      this.thumbnails = null;
      this.currentThumbnail = null;
      this.boundHandlers = {};
    }
  }

  customElements.define('async-carousel', AsyncCarousel);
}


/**
 *  @class
 *  @function GalleryCarousel
 */

if (!customElements.get('gallery-carousel')) {
  class GalleryCarousel extends HTMLElement {
    constructor() {
      super();
      this.main = null;
      this.thumbnails = null;
      this.shouldAutoplay = false;
      this.originalSlides = [];
      this.originalThumbnails = [];
      this.activeMediaComponents = new Map();
      this.rafId = null;
      this.boundHandlers = {};
      this.trackpadCleanup = null;
      this.progressBarCleanup = null;
      this.mainCarouselEl = null;
      this.centerResizeObserver = null;
      this.centerRafId = null;
      this.centerImageLoadCleanup = null;
      this.containAspectRatioCleanup = null;
    }

    connectedCallback() {
      const mainCarousel = this.querySelector('[id^="Main-Carousel"]');
      const thumbnailCarousel = this.querySelector('[id^="Thumbnail-Carousel"]');
    
      if (!mainCarousel || !thumbnailCarousel) {
        console.error('Main or thumbnail carousel element not found.');
        return;
      }
    
      this.originalSlides = [...mainCarousel.querySelectorAll('.splide__slide')];
      this.originalThumbnails = [...thumbnailCarousel.querySelectorAll('.splide__slide')];
    
      this.shouldAutoplay = this.getAttribute('data-autoplay') === 'true';
      mainCarousel.classList.add('is-initializing');
    
      const mainOptions = this.getCarouselOptions(mainCarousel);
      const thumbnailOptions = this.getCarouselOptions(thumbnailCarousel);
      const initialSlideIndex = this.getInitialSlideIndex(thumbnailCarousel);
    
      mainOptions.start = initialSlideIndex;
      thumbnailOptions.start = initialSlideIndex;
    
      this.initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions);
    
      const enableFiltering = this.dataset.mediaGrouping === "true";
      if (enableFiltering) {
        const defaultFilter = this.dataset.filterSelected;
        this.selectedSlideIndex = initialSlideIndex;
        this.filterSlides(defaultFilter, true);
        
        this.boundHandlers.filterChange = (e) => this.filterSlides(e.target.value, false);
        
        document.querySelectorAll(".variant-picker__color input[type='radio']").forEach((radio) => {
          radio.addEventListener("change", this.boundHandlers.filterChange);
        });
      }

      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 768) {
        this.autoplayFirstVideoInGrid();
      }

      this.syncContainAspectRatios();
      this.recenterOnMediaLoad();

      this.boundHandlers.resize = () => this.handleResize();
      window.addEventListener('resize', this.boundHandlers.resize);
    }

    shouldCenterActiveMedia() {
      return Boolean(
        this.main &&
          this.mainCarouselEl?.classList.contains('main-carousel--fit-center') &&
          window.matchMedia('(max-width: 1023px)').matches
      );
    }

    clearMediaCentering() {
      if (this.centerRafId) {
        cancelAnimationFrame(this.centerRafId);
        this.centerRafId = null;
      }

      this.centerResizeObserver?.disconnect();
      this.centerResizeObserver = null;
      this.centerImageLoadCleanup?.();
      this.centerImageLoadCleanup = null;
    }

    clearContainAspectRatios() {
      this.containAspectRatioCleanup?.();
      this.containAspectRatioCleanup = null;
    }

    syncContainAspectRatios() {
      this.clearContainAspectRatios();

      if (!this.mainCarouselEl?.classList.contains('main-carousel--fit-contain')) return;

      const cleanups = [];
      const syncImageRatio = (image) => {
        if (!image.naturalWidth || !image.naturalHeight) return;

        const mediaContainer = image.closest('.product-media-container');
        if (!mediaContainer) return;

        const imageRatio = image.naturalWidth / image.naturalHeight;
        mediaContainer.style.setProperty(
          '--pdp-media-ratio',
          imageRatio.toString()
        );
      };

      this.mainCarouselEl.querySelectorAll('.product-media-container img').forEach((image) => {
        syncImageRatio(image);
        if (image.complete) return;

        const handleLoad = () => syncImageRatio(image);
        image.addEventListener('load', handleLoad, { once: true });
        cleanups.push(() => image.removeEventListener('load', handleLoad));
      });

      if (cleanups.length) {
        this.containAspectRatioCleanup = () => cleanups.forEach((cleanup) => cleanup());
      }
    }

    recenterOnMediaLoad() {
      this.clearMediaCentering();
      if (!this.shouldCenterActiveMedia()) return;

      const activeSlide = this.main.Components?.Elements?.slides?.[this.main.index];
      const mediaContainer = activeSlide?.querySelector('.product-media-container');
      if (!mediaContainer) return;

      const image = mediaContainer.querySelector('img');

      // Double-rAF waits for the browser to commit autoWidth before Splide measures.
      // ResizeObserver covers cached Aprimo images whose load already fired while
      // rendered width is still settling; load/decode catch late-arriving images.
      const scheduleRecenter = () => {
        if (!this.shouldCenterActiveMedia()) return;
        if (this.centerRafId) cancelAnimationFrame(this.centerRafId);

        this.centerRafId = requestAnimationFrame(() => {
          this.centerRafId = requestAnimationFrame(() => {
            this.centerRafId = null;
            if (!this.shouldCenterActiveMedia()) return;

            this.main.Components?.Move?.reposition();
          });
        });
      };

      this.centerResizeObserver = new ResizeObserver(scheduleRecenter);
      this.centerResizeObserver.observe(mediaContainer);
      scheduleRecenter();

      if (!image) return;

      image.addEventListener('load', scheduleRecenter, { once: true });
      this.centerImageLoadCleanup = () => image.removeEventListener('load', scheduleRecenter);
      image.decode?.().then(scheduleRecenter).catch(() => {});
    }

    shouldEnableTrackpadScroll(mainCarousel) {
      if (!mainCarousel || !this.main) return false;
      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 1024) return false;
      return mainCarousel.classList.contains('is-active');
    }

    syncTrackpadScroll(mainCarousel) {
      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (!this.shouldEnableTrackpadScroll(mainCarousel)) return;

      const track = this.main?.root?.querySelector('.splide__track');
      if (!track) return;

      this.trackpadCleanup = enableTrackpadScroll(this.main, track, { throttle: 800 });
    }

    handleResize() {
      if (this.mainCarouselEl) {
        this.syncTrackpadScroll(this.mainCarouselEl);
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    getCarouselOptions(carouselElement) {
      return JSON.parse(carouselElement.getAttribute('data-splide') || '{}');
    }

    getInitialSlideIndex(thumbnailCarousel) {
      if (!thumbnailCarousel) return 0;
      const selectedThumbnailSlide = thumbnailCarousel.querySelector('.splide__slide[data-selected="true"]');
      if (selectedThumbnailSlide) {
        return [...thumbnailCarousel.querySelectorAll('.splide__slide')].indexOf(selectedThumbnailSlide);
      }
      return 0;
    }

    initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions) {
      this.mainCarouselEl = mainCarousel;
      this.main = new Splide(mainCarousel, mainOptions);
      this.thumbnails = new Splide(thumbnailCarousel, thumbnailOptions);
      const isVerticalThumbnail = thumbnailCarousel.getAttribute('data-thumbnail') === 'vertical';

      if (isVerticalThumbnail) {
        this.thumbnails.on('mounted', () => {
          const thumbnailList = thumbnailCarousel.querySelector('.splide__list');
          if (thumbnailList) {
            thumbnailList.setAttribute('role', 'tablist');
          }
        });
        this.thumbnails.on('mounted', this.updateThumbnailARIA.bind(this));
      }
      
      this.main.on('mounted', () => {
        mainCarousel.classList.remove('is-initializing');
    
        if (this.main.index !== undefined) {
            this.updateSlideCounter(this.main.index);
        }
      });

      this.main.on('active', this.handleMainActiveSlide.bind(this));

      this.main.on('move', (newIndex, prevIndex) => {
        if (typeof prevIndex !== 'undefined' && prevIndex !== null) {
          const prevSlide = this.main.Components.Elements.slides[prevIndex];
          if (prevSlide) {
            this.pauseMediaInSlide(prevSlide);
          }
        }
      });

      this.thumbnails.mount();
      this.main.sync(this.thumbnails);
      this.main.mount();

      this.main.on('moved', (newIndex) => {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        
        this.rafId = requestAnimationFrame(() => {
          this.updateSlideCounter(newIndex);
          this.updateMediaBadgeVisibility(newIndex);
          this.rafId = null;
        });
      });

      this.main.on('mounted', () => {
        this.updateMediaBadgeVisibility(this.main.index);
      });
      
      this.updateSlideCounter(this.main.index);
      this.updateMediaBadgeVisibility(this.main.index);
      this.syncTrackpadScroll(mainCarousel);

      const progressBar = this.querySelector('.splide-carousel-progress-bar');
      const progressContainer = this.querySelector('.main-carousel-progress');
      if (progressBar && progressContainer) {
        this.progressBarCleanup = initializePdpSwipeIndicator(
          this.main,
          progressContainer,
          progressBar,
          this
        );
      }
    }

    pauseMediaInSlide(slideElement) {
      if (!slideElement) return;
      const mediaElements = slideElement.querySelectorAll(
        'deferred-media, product-model, video, iframe'
      );
      mediaElements.forEach(media => {
        if (typeof media.pause === 'function') {
          media.pause();
        } else if (media.nodeName === 'VIDEO') {
          media.pause();
        } else if (media.nodeName === 'IFRAME') {
          if (media.classList.contains('js-youtube')) {
            media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (media.classList.contains('js-vimeo')) {
            media.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    }

    updateSlideCounter(newIndex) {
      const totalSlides = this.main.length;
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement && totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
        currentSlideElement.textContent = newIndex + 1;
      }
    }

    updateMediaBadgeVisibility(index) {
      const badge = this.querySelector('.main-carousel .card__badge');
      if (!badge) return;
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      badge.hidden = isMobile && index !== 0;
    }

    handleMainActiveSlide(newSlide) {
      const activeSlideElement = newSlide.slide;

      const hasProductModel = activeSlideElement.querySelector('product-model') !== null;
      if (this.main && this.main.Components && this.main.Components.Drag) {
        this.main.Components.Drag.disable(hasProductModel);
      }

      const mediaComponent = activeSlideElement.querySelector('deferred-media, product-model');

      if (mediaComponent) {
        if (this.shouldAutoplay) {
          if (typeof mediaComponent.activate === 'function') {
            mediaComponent.activate();
          } else if (typeof mediaComponent.play === 'function') {
            mediaComponent.play();
          }
        } else {
          if (typeof mediaComponent.pause === 'function') {
            mediaComponent.pause();
          }
        }
      }
      this.handleActiveSlide(activeSlideElement);
    }

    handleActiveSlide(slideElement) {
      if (slideElement && !slideElement.dataset.played && this.shouldAutoplay) {
         slideElement.dataset.played = true;
      }
    }

    updateCarouselImages(mediaId) {
      if (!this.main) {
        return;
      }
      const mainSlides = this.main.Components.Elements.slides;
      const targetSlide = mainSlides.find(slide => slide.getAttribute('data-media-id') === mediaId.toString());

      if (targetSlide) {
          const targetIndex = mainSlides.indexOf(targetSlide);
          if (targetIndex !== -1) {
              this.main.go(targetIndex, { transition: false });
          }
      }
      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 768) {
        const galleryListsContainer = this.querySelector('.splide__gallery');
        if (galleryListsContainer) {
          const slides = galleryListsContainer.querySelectorAll('.splide__slide');
          
          const slideToMove = Array.from(slides).find(item => item.getAttribute('data-media-id') === mediaId.toString());
      
          if (slideToMove) {
            slides.forEach(slide => {
              if (slide !== slideToMove) {
                slide.classList.remove('splide__slide--current-variant');
              }
            });
            slideToMove.classList.add('splide__slide--current-variant');
      
            if (galleryListsContainer.firstElementChild !== slideToMove) {
              galleryListsContainer.insertBefore(slideToMove, galleryListsContainer.firstElementChild);
      
              const headerElem = document.querySelector('.header');
              const headerOffset = headerElem ? headerElem.offsetHeight + 16 : 16;
              const elementPosition = slideToMove.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - headerOffset;
      
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }
        }
      }
    }

    updateThumbnailARIA() {
      if (!this.thumbnails || !this.thumbnails.Components || !this.thumbnails.Components.Elements.list) return;
      const thumbnailItems = this.thumbnails.Components.Elements.list.querySelectorAll('.splide__slide');

      thumbnailItems.forEach((thumbnailItem) => {
        thumbnailItem.setAttribute('role', 'tab');
      });
    }

    filterSlides(group, isInitialFilter = false) {
      const isDesktopGrid = this.hasAttribute('desktop-grid') && window.innerWidth >= 768;
      
      if (isDesktopGrid) {
        this.filterSlidesDesktopGrid(group);
        return;
      }
      
      this.filterSlidesCarousel(group, isInitialFilter);
    }

    autoplayFirstVideoInGrid() {
      if (!this.shouldAutoplay) return;
      
      const galleryContainer = this.querySelector('.splide__gallery');
      if (!galleryContainer) return;
      
      const slides = galleryContainer.querySelectorAll('.splide__slide');
      
      for (const slide of slides) {
        if (slide.style.display === 'none' || slide.classList.contains('hidden-by-filter')) {
          continue;
        }
        
        const mediaComponent = slide.querySelector('deferred-media, product-model');
        if (mediaComponent) {
          if (typeof mediaComponent.activate === 'function') {
            mediaComponent.activate();
          } else if (typeof mediaComponent.play === 'function') {
            mediaComponent.play();
          }
          break; 
        }
      }
    }

    filterSlidesDesktopGrid(group) {
      const galleryContainer = this.querySelector('.splide__gallery');
      if (!galleryContainer) return;
      
      const slides = galleryContainer.querySelectorAll('.splide__slide');
      let visibleCount = 0;
      let firstVisibleMediaFound = false;
      
      slides.forEach(slide => {
        const shouldShow = !group || group.trim() === "" || slide.dataset.mediaGroup === group;
        
        if (shouldShow) {
          slide.style.display = '';
          slide.classList.remove('hidden-by-filter');
          visibleCount++;
          
          const deferredMedia = slide.querySelector('deferred-media');
          if (deferredMedia) {
            if (deferredMedia.hasAttribute('loaded')) {
              this.ensureMediaFunctionality(deferredMedia);
            } 
            else if (deferredMedia.hasAttribute('autoplay')) {
              if (!deferredMedia.visibilityObserver) {
                deferredMedia._initiateAutoplayObserver();
              }
            }
            
            if (!firstVisibleMediaFound && this.shouldAutoplay) {
              if (typeof deferredMedia.activate === 'function') {
                deferredMedia.activate();
              } else if (typeof deferredMedia.play === 'function') {
                deferredMedia.play();
              }
              firstVisibleMediaFound = true;
            }
          }
        } else {
          slide.style.display = 'none';
          slide.classList.add('hidden-by-filter');
          
          const deferredMedia = slide.querySelector('deferred-media');
          if (deferredMedia) {
            if (deferredMedia.hasAttribute('playing')) {
              deferredMedia.pause();
            }
            
            if (deferredMedia.visibilityObserver) {
              deferredMedia.visibilityObserver.disconnect();
              deferredMedia.visibilityObserver = null;
            }
          }
        }
      });
      
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');
      
      if (currentSlideElement && totalSlidesElement) {
        currentSlideElement.textContent = visibleCount > 0 ? '1' : '0';
        totalSlidesElement.textContent = visibleCount;
      }
    }
    

    filterSlidesCarousel(group, isInitialFilter = false) {
      if (!this.main || !this.thumbnails) {
        console.error('Splide instances not initialized');
        return;
      }
      
      let mainList = this.main.Components.Elements.list;
      let thumbList = this.thumbnails.Components.Elements.list;
    
      if (!mainList || !thumbList) {
        console.error('Splide list element not found for main or thumbnails.');
        return;
      }
      
      this.saveMediaStates();
    
      mainList.innerHTML = "";
      thumbList.innerHTML = "";
    
      let slidesToShow = this.originalSlides;
      let thumbsToShow = this.originalThumbnails;
    
      if (group && group.trim() !== "") {
        let filteredSlides = this.originalSlides.filter(slide => slide.dataset.mediaGroup === group);
        let filteredThumbs = this.originalThumbnails.filter(slide => slide.dataset.mediaGroup === group);
    
        if (filteredSlides.length > 0 && filteredThumbs.length > 0) {
            slidesToShow = filteredSlides;
            thumbsToShow = filteredThumbs;
        }
      }
    
      this.updateArrowVisibility(thumbsToShow.length);
    
      const mainFragment = document.createDocumentFragment();
      const thumbFragment = document.createDocumentFragment();
      
      slidesToShow.forEach(slide => {
        const clonedSlide = slide.cloneNode(true);
        mainFragment.appendChild(clonedSlide);
        this.initializeMediaInSlide(clonedSlide);
      });
      
      thumbsToShow.forEach(slide => {
        const clonedThumb = slide.cloneNode(true);
        thumbFragment.appendChild(clonedThumb);
      });
      
      mainList.appendChild(mainFragment);
      thumbList.appendChild(thumbFragment);
    
      try {
          this.main.refresh();
          this.thumbnails.refresh();
    
          if (slidesToShow.length > 0) {
              let targetIndex = 0;
              
              if (isInitialFilter) {
                const selectedSlide = slidesToShow.find(slide => 
                  slide.querySelector('[data-selected="true"]') || 
                  slide.hasAttribute('data-selected')
                );
                
                if (selectedSlide) {
                  targetIndex = slidesToShow.indexOf(selectedSlide);
                }
              }
              
              this.main.go(targetIndex);
              this.thumbnails.go(targetIndex);
              this.updateSlideCounter(targetIndex);
              
              this.restoreMediaStates();
          } else {
              this.updateSlideCounter(-1);
              console.warn("No slides to display in the carousel after filtering.");
          }
      } catch (error) {
          console.error("Error refreshing Splide instances:", error);
      }
    
      this.querySelectorAll('responsive-image').forEach(responsiveImg => {
        if (responsiveImg.connectedCallback && typeof responsiveImg.connectedCallback === 'function') {
          responsiveImg.connectedCallback();
        }
        else if (responsiveImg.init && typeof responsiveImg.init === 'function') {
          responsiveImg.init();
        }
      });
    
      this.updateThumbnailARIA();
      this.syncTrackpadScroll(this.mainCarouselEl);
      this.syncContainAspectRatios();
      this.recenterOnMediaLoad();
    }

    initializeMediaInSlide(slide) {
      if (!slide) return;
      
      const deferredMedia = slide.querySelector('deferred-media');
      if (deferredMedia) {
        try {
          deferredMedia.removeAttribute('loaded');
          deferredMedia.removeAttribute('playing');
          deferredMedia.removeAttribute('has-play-pause-button');
          
          deferredMedia.mediaElement = null;
          deferredMedia.playerController = null;
          
          const poster = deferredMedia.querySelector('[id^="Deferred-Poster-"]');
          const template = deferredMedia.querySelector('template');
          
          if (poster && template) {
            const boundActivate = deferredMedia.activate.bind(deferredMedia);
            
            if (deferredMedia.boundActivate) {
              poster.removeEventListener('click', deferredMedia.boundActivate);
            }
            
            poster.addEventListener('click', boundActivate);
            
            poster.style.display = '';
            
            deferredMedia.poster = poster;
            deferredMedia.template = template;
            deferredMedia.boundActivate = boundActivate;
            
            if (deferredMedia.hasAttribute('autoplay') && deferredMedia._initiateAutoplayObserver) {
              deferredMedia._initiateAutoplayObserver();
            }
          }
        } catch (error) {
          console.error('Error initializing deferred-media:', error);
        }
      }
      
      const productModel = slide.querySelector('product-model');
      if (productModel) {
        try {
          if (productModel.connectedCallback) {
            productModel.connectedCallback();
          }
        } catch (error) {
          console.error('Error initializing product-model:', error);
        }
      }
    }

    ensureMediaFunctionality(mediaElement) {
      if (!mediaElement || mediaElement.nodeType !== 1) return;
      
      if (mediaElement.hasAttribute('loaded') && mediaElement.hasAttribute('autoplay')) {
        const playPauseButton = mediaElement.querySelector('.deferred-media-control__play-pause');
        if (playPauseButton && !mediaElement.hasAttribute('has-play-pause-button')) {
          const boundHandleClick = mediaElement._handlePlayPauseClick?.bind(mediaElement);
          if (boundHandleClick) {
            playPauseButton.addEventListener('click', boundHandleClick);
            mediaElement.setAttribute('has-play-pause-button', '');
            mediaElement.playPauseButton = playPauseButton;
          }
        }
      }
      
      const poster = mediaElement.querySelector('[id^="Deferred-Poster-"]');
      if (poster && !mediaElement.hasAttribute('loaded')) {
        const boundActivate = mediaElement.activate?.bind(mediaElement);
        if (boundActivate) {
          poster.removeEventListener('click', boundActivate);
          poster.addEventListener('click', boundActivate);
          mediaElement.boundActivate = boundActivate;
        }
      }
    }

    saveMediaStates() {
      this.activeMediaComponents.clear();
      this.querySelectorAll('deferred-media, product-model').forEach(media => {
        const mediaId = media.closest('[data-media-id]')?.dataset.mediaId;
        if (mediaId) {
          this.activeMediaComponents.set(mediaId, {
            isLoaded: media.hasAttribute('loaded'),
            isPlaying: media.hasAttribute('playing'),
            hasAutoplay: media.hasAttribute('autoplay')
          });
        }
      });
    }
    
    restoreMediaStates() {
      this.activeMediaComponents.forEach((state, mediaId) => {
        const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide) {
          const media = slide.querySelector('deferred-media, product-model');
          if (media) {
            if (state.isLoaded && !media.hasAttribute('loaded')) {
              media._initializeMedia().then(loaded => {
                if (loaded && state.isPlaying) {
                  setTimeout(() => media.activate(), 100);
                }
              });
            }
            else if (state.isPlaying && media.hasAttribute('loaded')) {
              setTimeout(() => media.activate(), 100);
            }
            else if (state.hasAutoplay && !media.hasAttribute('loaded')) {
              media._initiateAutoplayObserver();
            }
          }
        }
      });
    }

    updateArrowVisibility(slideCount) {
      const arrows = this.querySelectorAll('.splide__arrows-thumbnail');
      const shouldShow = slideCount > 5;
    
      arrows.forEach(arrow => {
        if (shouldShow) {
          arrow.classList.remove('hidden');
        } else {
          arrow.classList.add('hidden');
        }
      });
    }

    cleanup() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      this.clearMediaCentering();
      this.clearContainAspectRatios();

      if (this.progressBarCleanup) {
        this.progressBarCleanup();
        this.progressBarCleanup = null;
      }

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.boundHandlers.resize) {
        window.removeEventListener('resize', this.boundHandlers.resize);
      }

      if (this.boundHandlers.filterChange) {
        const radios = document.querySelectorAll(".variant-picker__color input[type='radio']");
        radios.forEach(radio => {
          radio.removeEventListener("change", this.boundHandlers.filterChange);
        });
      }

      if (this.main) {
        this.main.destroy();
        this.main = null;
      }

      if (this.thumbnails) {
        this.thumbnails.destroy();
        this.thumbnails = null;
      }

      this.originalSlides = [];
      this.originalThumbnails = [];
      this.activeMediaComponents.clear();
      this.boundHandlers = {};
      this.mainCarouselEl = null;
    }
  }

  customElements.define('gallery-carousel', GalleryCarousel);
}




/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.dataset.url ? this.loadRecommendations() : console.error('No data-url attribute found.');
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim()) {
          this.renderRecommendations(recommendations.innerHTML);
        } else {
          console.warn('No product recommendations found.');
        }

      } catch (error) {
        console.error('Error fetching product recommendations:', error);
      }
    }

    renderRecommendations(html) {
      this.innerHTML = html;
      this.initCarousels();
      this.classList.add('product-recommendations--loaded');
    }

    initCarousels() {
      const carousels = this.querySelectorAll('splide-carousel');
      carousels.forEach(carousel => carousel.connectedCallback?.());
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}



class ComponentDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('.drawer-overlay');
    this.drawer = this.querySelector('.drawer-content');
    this.closeButton = this.querySelector('.close-drawer-btn');
    this.triggerButton = null;

    this.overlay.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'dialog');
    }
    document.addEventListener('keydown', this.handleKeyPress);
  }
  
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('focus', this.trapFocus, true);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.closeButton.focus();
    document.addEventListener('focus', this.trapFocus, true);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('focus', this.trapFocus, true);
  
    if (this.triggerButton) {
      this.triggerButton.focus();
      this.triggerButton = null;
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  trapFocus(event) {
    if (!this.contains(event.target)) {
      event.stopPropagation();
      this.closeButton.focus();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }
}

customElements.define('component-drawer', ComponentDrawer);

class SearchDrawer extends ComponentDrawer {
  constructor() {
    super();
    this.predictiveSearch = this.querySelector('predictive-search');
    this.openTransitionEndHandler = this.openTransitionEndHandler.bind(this);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.addEventListener('transitionend', this.openTransitionEndHandler);
    document.addEventListener('focus', this.trapFocus, true);
  }

  openTransitionEndHandler(event) {
    if (event.target === this.overlay) {
      this.removeEventListener('transitionend', this.openTransitionEndHandler);

      if (this.predictiveSearch) {
        setTimeout(() => {
          const focusElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
          if (focusElement && typeof focusElement.focus === 'function') {
            focusElement.focus();
          }
        }, 150);
      }
    }
  }

  close() {
    if (this.predictiveSearch) {
      const inputElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
      if (inputElement) {
        inputElement.value = '';
      }
      if (this.predictiveSearch.hasAttribute('open')) {
        this.predictiveSearch.removeAttribute('open');
      }
      this.predictiveSearch.setAttribute('results', 'false');
    }

    super.close();
  }
}


customElements.define('search-drawer', SearchDrawer);

class DrawerButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  connectedCallback() {
    this.targetId = this.getAttribute('data-target');
    this.targetDrawer = document.getElementById(this.targetId);
    
    this.setAttribute('tabindex', '0');
    this.setAttribute('role', 'button');
    
    if (this.targetDrawer) {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeyPress);
    } else {
      console.warn(`Drawer element with ID '${this.targetId}' does not exist.`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  }

  handleClick() {
    if (this.targetDrawer && typeof this.targetDrawer.open === 'function') {
      this.targetDrawer.open(this); 
    }
  }
}

customElements.define('drawer-button', DrawerButton);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.initElements();
      this.bindEvents();
    }

    initElements() {
      const modal = document.getElementById('product-quick-view');
      this.elements = {
        overlay: document.querySelector('.product-quick-view__overlay'),
        modal,
        body: document.body,
        modalContent: modal?.querySelector('#product-quick-view__product-content')
      };
    }

    bindEvents() {
      const { overlay, modal } = this.elements;
      this.addEventListener('click', this.onQuickViewClick.bind(this));
      this.addEventListener('keydown', this.onQuickViewKeydown.bind(this));

      // Overlay click closes the layer (the overlay is part of the modal shell
      // and is always present at init time).
      overlay?.addEventListener('click', this.closeQuickView.bind(this));

      // Wishlist on the image uses `data-wishlist-toggle` (PLP parity); Swish
      // headless binds via theme.watch when section HTML is injected.

      // The close button now lives inside the injected section content (it
      // moved into the header so it can scroll with the body on mobile —
      // Figma 4168:69325). Bind via event delegation so it works regardless
      // of when the close element is added to the DOM.
      modal?.addEventListener('click', (event) => {
        if (event.target.closest('.product-quick-view__close, [data-quick-view-close]')) {
          event.preventDefault();
          this.closeQuickView();
        }
      });

      document.addEventListener('keydown', this.onKeyDown.bind(this));
      modal?.addEventListener('transitionend', this.onTransitionEnd.bind(this));
    }

    onKeyDown(event) {
      if (event.key !== 'Escape') return;
      if (!this.elements.modal.classList.contains('quick-view-loaded')) return;
      // Let the back-in-stock modal handle Escape first when it is open.
      if (document.querySelector('.product-popup-modal--back-in-stock[open]')) return;
      this.closeQuickView();
    }

    onQuickViewKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); 
        this.onQuickViewClick(event);
      }
    }
    trapFocus(event) {
      if (event.key !== 'Tab') return;
      // When the back-in-stock modal is open, its own focus trap takes over.
      if (document.querySelector('.product-popup-modal--back-in-stock[open]')) return;

      const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const focusableContent = Array.from(
        this.elements.modal.querySelectorAll(focusableElements)
      ).filter((el) => !el.closest('.product-popup-modal--back-in-stock'));
      const firstFocusableElement = focusableContent[0];
      const lastFocusableElement = focusableContent[focusableContent.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }

    portalBackInStockModals() {
      this.cleanupPortaledBackInStockModals();

      const modals = this.elements.modalContent.querySelectorAll(
        '.product-popup-modal--back-in-stock'
      );
      modals.forEach((modal) => {
        modal.dataset.quickViewPortaled = 'true';
        document.body.appendChild(modal);
      });
    }

    cleanupPortaledBackInStockModals() {
      document
        .querySelectorAll('.product-popup-modal--back-in-stock[data-quick-view-portaled="true"]')
        .forEach((modal) => {
          modal.removeAttribute('open');
          modal.removeAttribute('closing');
          modal.remove();
        });
      if (!document.querySelector('.product-popup-modal[open]')) {
        document.body.classList.remove('overflow-hidden');
      }
    }

    onTransitionEnd() {
      if (
        !this.elements.modal.classList.contains('quick-view-loaded') &&
        this.elements.modalContent.innerHTML !== ''
      ) {
        this.cleanupPortaledBackInStockModals();
        this.elements.modalContent.innerHTML = '';
      }
    }


    async onQuickViewClick(event) {
      event.preventDefault();
      const quickViewUrl = this.buildProductUrl();
    
      if (!quickViewUrl) return;
    
      this.classList.add('loading');
      this.elements.modalContent.classList.add('is-loading');
      try {
        this.cache = this.cache || {};
        if (!this.cache[quickViewUrl] || Date.now() - this.cache[quickViewUrl].timestamp > 60000) {
          const content = await this.fetchProductContent(quickViewUrl);
          this.cache[quickViewUrl] = { content, timestamp: Date.now() };
        }
        this.renderQuickView(this.cache[quickViewUrl].content, quickViewUrl);
      } finally {
        this.classList.remove('loading');
        setTimeout(() => {
          this.elements.modalContent.classList.remove('is-loading');
        }, 150);
      }
    }

    buildProductUrl() {
      const url = this.dataset.productUrl;
      if (!url) return '';
      /* Preserve `?variant=…` so the Quick-View layer opens with the
         variant the user selected on the PLP card (set by
         product-tile.js `_updateProductLink`). Other query params are
         dropped — only `variant` is meaningful for the QV section. */
      const [pathname, query = ''] = url.split('?');
      const params = new URLSearchParams(query);
      const variant = params.get('variant');
      const qs = new URLSearchParams({ view: 'quick-view' });
      if (variant) qs.set('variant', variant);
      return `${pathname}?${qs.toString()}`;
    }   

    async fetchProductContent(url) {
      const response = await fetch(url);
      const text = await response.text();
      return new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view__product-content').innerHTML;
    }

    renderQuickView(content, url) {
      if (!content) return;
    
      this.elements.modalContent.innerHTML = content;
      /* Compare only works where the PLP store, drawer and CTA are loaded.
         Off those pages the button would render and do nothing. */
      const compareButton = this.elements.modalContent.querySelector('.product-form__compare-btn');
      if (!window.armadaCompare && compareButton) {
        compareButton.remove();
      }
      requestAnimationFrame(() => {
        this.portalBackInStockModals();
        this.loadJavaScriptFiles();
        this.initializeShopifyComponents();
        this.openQuickView();
        this.dispatchQuickViewOpenEvent(url);
      });
    }

    loadJavaScriptFiles() {
      if (!this.loadedScripts) this.loadedScripts = new Set();
    
      this.elements.modalContent.querySelectorAll('script[src]').forEach(script => {
        if (!this.loadedScripts.has(script.src) && !document.querySelector(`script[src="${script.src}"]`)) {
          const newScript = document.createElement('script');
          newScript.src = script.src;
          newScript.async = true;
          document.head.appendChild(newScript);
          this.loadedScripts.add(script.src);
        }
      });
    }
    
    initializeShopifyComponents() {
      setTimeout(() => {
        if (Shopify?.PaymentButton) Shopify.PaymentButton.init();
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
      }, 200);
    }
    
    openQuickView() {
      const { body, modal } = this.elements;
      body.classList.add('quickview-open');
      modal.classList.add('quick-view-loaded');
      // Close button lives inside the injected content — query it now.
      modal?.querySelector('.product-quick-view__close')?.focus();

      if (!this.isFocusTrapped) {
        this.isFocusTrapped = true;
        document.addEventListener('keydown', this.trapFocus.bind(this));
      }
    }
    
    closeQuickView() {
      const { body, modal } = this.elements;
      body.classList.remove('quickview-open');
      modal.classList.remove('quick-view-loaded');
      this.cleanupPortaledBackInStockModals();

      if (this.isFocusTrapped) {
        this.isFocusTrapped = false;
        document.removeEventListener('keydown', this.trapFocus.bind(this));
      }
    }
    
    

    dispatchQuickViewOpenEvent(url) {
      document.dispatchEvent(new CustomEvent('quick-view:loaded', {
        detail: { productUrl: url }
      }));
    }
  }

  customElements.define('quick-view', QuickView);
}

/**
 * Quick View → cart drawer hand-off (fired by product-form.js on add-to-cart).
 *
 * The cart drawer's panel covers exactly the same slot as the layer, so closing
 * one while the other opens reads as the drawer flickering shut and back open.
 * Instead the cart is prepared behind the layer without animating. The white
 * panel and backdrop remain visually unchanged while the old content fades
 * out, then the cart content fades in. See the hand-off block in quick-view.css.
 */
document.addEventListener('quick-view:hand-off-to-cart', () => {
  const modal = document.getElementById('product-quick-view');
  const cartDrawer = document.querySelector('cart-drawer');
  const content = modal?.querySelector('#product-quick-view__product-content');
  if (!modal || modal.dataset.handingOffToCart === 'true') return;

  const { body } = document;
  const closeLayer = () => {
    modal.classList.remove('quick-view-loaded');
    body.classList.remove('quickview-open');
  };

  // Nothing to hand over to (drawer missing or not shown at this breakpoint).
  if (!content || !cartDrawer || getComputedStyle(cartDrawer).display === 'none') {
    closeLayer();
    return;
  }

  let observer = null;
  let failSafe = null;
  let fadeTimer = null;
  let cartInPlace = cartDrawer.classList.contains('active');
  let contentFaded = false;
  let finished = false;

  // Match `--duration-default` (200ms) plus a short buffer for the failsafe.
  const CONTENT_FADE_MS = 300;

  modal.dataset.handingOffToCart = 'true';
  body.classList.add('quickview-cart-handoff');

  const finish = () => {
    if (finished) return;
    finished = true;

    clearTimeout(failSafe);
    clearTimeout(fadeTimer);
    observer?.disconnect();
    content.removeEventListener('transitionend', onFadeEnd);
    delete modal.dataset.handingOffToCart;

    // One frame with every transition suppressed: the drawer's panel and
    // backdrop take over from the layer's identical ones without animating.
    body.classList.add('quickview-cart-handoff-end', 'quickview-cart-content-in');
    modal.classList.remove('quick-view-loaded');
    body.classList.remove('quickview-open', 'quickview-cart-handoff');

    // `quick-view` clears the injected markup on transitionend, which cannot
    // fire while transitions are off, so run its teardown here instead: drop
    // the markup and any back-in-stock modal it portaled onto the body.
    content.innerHTML = '';
    document
      .querySelectorAll('.product-popup-modal--back-in-stock[data-quick-view-portaled="true"]')
      .forEach((portaled) => portaled.remove());
    if (!document.querySelector('.product-popup-modal[open]')) {
      body.classList.remove('overflow-hidden');
    }

    requestAnimationFrame(() => {
      body.classList.remove('quickview-cart-handoff-end', 'quickview-cart-content-in');
    });
  };

  // Swap only once the configuration has faded AND the cart is behind it.
  const swapWhenReady = () => {
    if (cartInPlace && contentFaded) finish();
  };

  const onFadeEnd = (event) => {
    if (event.target !== content || event.propertyName !== 'opacity') return;
    contentFaded = true;
    swapWhenReady();
  };

  content.addEventListener('transitionend', onFadeEnd);
  fadeTimer = setTimeout(() => {
    contentFaded = true;
    swapWhenReady();
  }, CONTENT_FADE_MS);

  // The drawer patches in its new markup and opens a few frames later.
  if (!cartInPlace) {
    observer = new MutationObserver(() => {
      if (!cartDrawer.classList.contains('active')) return;
      observer.disconnect();
      cartInPlace = true;
      swapWhenReady();
    });
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // If the drawer never opens, close the layer anyway so it cannot get stuck.
  failSafe = setTimeout(finish, 1500);
});


/**
 *  @class
 *  @function CollapsibleDetails
 */


if (!customElements.get('collapsible-details')) {
  class CollapsibleDetails extends HTMLElement {
    constructor() {
      super();
      this.toggleContent = this.toggleContent.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.updateHeight = this.updateHeight.bind(this);
      this.setResponsiveState = this.setResponsiveState.bind(this);
      this.isAnimating = false;
      this.rafId = null;
      this.resizeRafId = null;
    }

    connectedCallback() {
      // Guard against double-initialisation (e.g. if connectedCallback is ever
      // invoked again): drop previous observers so they don't accumulate.
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();

      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.querySelector('summary');
      this.contentEl = this.querySelector('.collapsible__content');
      this.contentInnerEl = this.querySelector('.collapsible__content-inner');

      if (!this.detailsEl || !this.summaryEl || !this.contentEl) return;
      
      this.wrapContent();
      this.setupInitialState();
      this.addEventListeners();
      
      if (this.contentInnerEl && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.debouncedUpdateHeight.bind(this));
        this.resizeObserver.observe(this.contentInnerEl);
      }
      
      if (this.detailsEl.dataset.responsive === 'true') {
        this.setResponsiveState();
        this.mediaQuery = window.matchMedia('(max-width: 768px)');
        this.handleMediaChange = this.throttle(this.setResponsiveState, 150);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      }
      
      if (this.contentInnerEl && 'MutationObserver' in window) {
        this.mutationObserver = new MutationObserver(
          this.throttle(this.updateContentHeight.bind(this), 100)
        );
        this.mutationObserver.observe(this.contentInnerEl, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: false
        });
      }
    }

    throttle(func, wait) {
      let timeout = null;
      let previous = 0;
      
      return (...args) => {
        const now = Date.now();
        const remaining = wait - (now - previous);
        
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          func.apply(this, args);
        } else if (!timeout) {
          timeout = setTimeout(() => {
            previous = Date.now();
            timeout = null;
            func.apply(this, args);
          }, remaining);
        }
      };
    }

    debouncedUpdateHeight() {
      if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
      this.resizeRafId = requestAnimationFrame(() => {
        this.updateHeight();
        this.resizeRafId = null;
      });
    }

    wrapContent() {
      if (!this.contentEl?.parentElement) return;
      
      if (this.contentEl.parentElement.classList.contains('collapsible__content-wrapper')) {
        this.contentWrapper = this.contentEl.parentElement;
        return;
      }
      
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible__content-wrapper';
      this.contentEl.parentNode.insertBefore(this.contentWrapper, this.contentEl);
      this.contentWrapper.appendChild(this.contentEl);
    }

    setupInitialState() {
      if (!this.detailsEl) return;
      
      const isOpen = this.detailsEl.hasAttribute('open');
      
      if (isOpen) {
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentEl.style.transform = 'translateY(0)';
        this.detailsEl.classList.add('is-open');
      } else {
        this.contentWrapper.style.cssText = 'height: 0';
        this.contentEl.style.transform = 'translateY(16px)';
      }
    }

    addEventListeners() {
      if (!this.summaryEl || !this.contentWrapper) return;
      
      this.summaryEl.addEventListener('click', this.toggleContent);
      this.contentWrapper.addEventListener('transitionend', this.onTransitionEnd, { passive: true });
    }

    toggleContent(event) {
      event.preventDefault();
      
      if (this.isAnimating) {
        this.pendingState = !this.detailsEl.open;
        return;
      }
      
      this[this.detailsEl.open ? 'closeContent' : 'openContent']();
    }

    openContent() {
      this.isAnimating = true;
      this.detailsEl.open = true;

      if (this.rafId) cancelAnimationFrame(this.rafId);

      this.rafId = requestAnimationFrame(() => {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.cssText = 'height: 0';
        this.contentEl.style.transform = 'translateY(16px)';

        this.rafId = requestAnimationFrame(() => {
          this.detailsEl.classList.add('is-open');
          this.contentWrapper.style.height = `${height}px`;
          this.contentEl.style.transform = 'translateY(0)';
          this.rafId = null;
        });
      });

      this.scheduleFinalizeFallback();
    }

    closeContent() {
      this.isAnimating = true;

      if (this.rafId) cancelAnimationFrame(this.rafId);

      this.rafId = requestAnimationFrame(() => {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;

        this.rafId = requestAnimationFrame(() => {
          this.detailsEl.classList.remove('is-open');
          this.contentWrapper.style.cssText = 'height: 0';
          this.contentEl.style.transform = 'translateY(16px)';
          this.rafId = null;
        });
      });

      this.scheduleFinalizeFallback();
    }

    // Safety net: if the height transition never finishes (cancelled by a
    // re-render, mid-transition height update, reduced-motion / transition:none,
    // hidden ancestor, etc.) `transitionend` never fires and `isAnimating`
    // would stay true forever, deadlocking the accordion. Always finalise.
    scheduleFinalizeFallback() {
      clearTimeout(this.finalizeTimer);
      let duration = 250;
      if (this.contentWrapper) {
        const computed = parseFloat(getComputedStyle(this.contentWrapper).transitionDuration);
        if (!isNaN(computed)) duration = computed * 1000;
      }
      this.finalizeTimer = setTimeout(() => this.finalizeToggle(), duration + 150);
    }

    finalizeToggle() {
      clearTimeout(this.finalizeTimer);
      this.isAnimating = false;

      if (!this.detailsEl.classList.contains('is-open')) {
        this.detailsEl.open = false;
      } else {
        this.contentWrapper.style.height = 'auto';
      }

      if (this.pendingState !== undefined) {
        const nextState = this.pendingState;
        this.pendingState = undefined;
        if (nextState !== this.detailsEl.open) {
          this[nextState ? 'openContent' : 'closeContent']();
        }
      }
    }

    onTransitionEnd(event) {
      if (event.propertyName !== 'height' || event.target !== this.contentWrapper) return;
      this.finalizeToggle();
    }

    updateHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    updateContentHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    disconnectedCallback() {
      this.summaryEl?.removeEventListener('click', this.toggleContent);
      this.contentWrapper?.removeEventListener('transitionend', this.onTransitionEnd);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      
      if (this.mediaQuery && this.handleMediaChange) {
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);
      }
      
      if (this.rafId) cancelAnimationFrame(this.rafId);
      if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
      clearTimeout(this.finalizeTimer);
    }

    setResponsiveState() {
      const isMobile = this.mediaQuery ? this.mediaQuery.matches : 
                       window.matchMedia('(max-width: 768px)').matches;
      
      if (isMobile && this.detailsEl.open) return;
      
      this.detailsEl.open = !isMobile;
      this.detailsEl.classList.toggle('is-open', !isMobile);
      
      if (isMobile) {
        this.contentWrapper.style.height = '0';
      } else {
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentEl.style.transform = 'translateY(0)';
        
        requestAnimationFrame(() => {
          const height = this.contentEl.scrollHeight;
          this.contentWrapper.style.height = `${height}px`;
        });
      }
    }
  }
  customElements.define('collapsible-details', CollapsibleDetails);

}

// Use a debounced resize handler for better performance
function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

window.addEventListener('resize', debounce(() => {
  document.querySelectorAll('collapsible-details details[data-responsive="true"]')
    .forEach(details => details.closest('collapsible-details').setResponsiveState());
}));

/**
 *  @class
 *  @function TabsComponent
 */

if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabsHeader = this.querySelector('.tabs-header');
      this.tabsContent = this.querySelector('.tabs-content');
      this.tabActiveIndicator = this.querySelector('.indicator');

      this.tabsHeader.addEventListener('click', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.activateTab(e.target);
        }
      });

      this.tabsHeader.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.handleKeyDown(e);
        }
      });

      this.activateTab(this.tabsHeader.querySelector('.tab-button'));

      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      }
    }

    activateTab(tab) {
      const tabIndex = tab.getAttribute('data-tab');

      this.tabsHeader.querySelectorAll('.tab-button').forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive);
        //t.setAttribute('tabindex', isActive ? '0' : '-1'); 
      });

      this.tabsContent.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.toggle('active', content.getAttribute('id') === tabIndex);
      });

      const tabRect = tab.getBoundingClientRect();
      const tabsHeaderRect = this.tabsHeader.getBoundingClientRect();
      const isRTL = getComputedStyle(this.tabsHeader).direction === 'rtl';
      const offset = isRTL
        ? tabsHeaderRect.right - tabRect.right
        : tabRect.left - tabsHeaderRect.left;

        this.tabsHeader.style.setProperty('--indicator-width', `${tabRect.width}px`);
        this.tabsHeader.style.setProperty('--indicator-offset', `${offset}px`);
    }

    handleKeyDown(e) {
      const key = e.key;
      const currentTab = e.target;
      let newTab;

      switch (key) {
        case 'ArrowRight':
          newTab = currentTab.nextElementSibling || this.tabsHeader.firstElementChild;
          break;
        case 'ArrowLeft':
          newTab = currentTab.previousElementSibling || this.tabsHeader.lastElementChild;
          break;
        case 'Enter':
        case 'Space':  
          this.activateTab(currentTab);
          return;
      }

      if (newTab && newTab.classList.contains('tab-button')) {
        e.preventDefault();
        newTab.focus(); 
      }
    }

    handleBlockSelect(e) {
      const blockId = e.detail.blockId;
      const tabToActivate = this.tabsHeader.querySelector(`[data-tab="tab-${blockId}"]`);
      if (tabToActivate) {
        this.activateTab(tabToActivate);
      }
    }
  }

  customElements.define('tabs-component', TabsComponent);
}

if (!customElements.get('card-product-swatch')) {
  class CardProductSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swatchButtons = this.querySelectorAll('.swatch-button');
      this.image = this.closest('.card-product').querySelector('.product-first-image img');
      this.link = this.closest('.card-product').querySelector('.product-link'); 

      this.swatchButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          this.handleSwatchInteraction(e.currentTarget, true);
        });

        button.addEventListener('mouseenter', (e) => {
          this.handleSwatchInteraction(e.currentTarget, false);
        });

        button.addEventListener('mouseleave', () => {
          const active = this.querySelector('.swatch-button.active');
          if (active) {
            this.updateProductImage(active);
            this.updateProductLink(active);
          }
        });
      });
    }

    handleSwatchInteraction(button, isClick) {
      if (isClick) {
        this.updateActiveSwatch(button);
        /* AAS-5630: only on a real click. Hover previews a colour and is undone
           on mouseleave, so following it would arm the wishlist with a colour
           the customer never chose. */
        this.updateWishlistVariant(button);
      }
      this.updateProductImage(button);
      this.updateProductLink(button);
    }

    /* This tile carries no variant data, so the variant comes from the same
       per-swatch product link the card navigates to. */
    updateWishlistVariant(button) {
      const link = button.getAttribute('data-link');
      if (!link) return;

      const variantId = new URLSearchParams(link.split('?')[1] || '').get('variant');
      if (!variantId) return;

      window.armadaSyncWishlistVariant?.(this.closest('.card-product'), variantId);
    }

    updateActiveSwatch(button) {
      this.swatchButtons.forEach((b) => b.classList.remove('active'));
      button.classList.add('active');
    }

    updateProductImage(button) {
      const newImageSrcset = button.getAttribute('data-srcset');
      const newImageSrc = button.getAttribute('data-src');
      const newRetinaSrcset = button.getAttribute('data-srcset-hd');
      if (!this.image) return;
      /* AAS-5559: .product-first-image is emitted by aprimo-image /
       * responsive-image, both of which wrap the img in a <picture> with a
       * resolution-gated <source>. A source outranks the img, so writing
       * src/srcset alone fetched the new colour and painted the old one on
       * every hi-DPI screen. See assets/picture-swap.js. */
      window.armadaPaintPicture?.(this.image, {
        src: newImageSrc,
        srcset: newImageSrcset,
        srcsetRetina: newRetinaSrcset,
      });
    }

    updateProductLink(button) {
      const newLink = button.getAttribute('data-link');
      if (newLink) {
        this.link.href = newLink;
      }
    }
  }

  customElements.define('card-product-swatch', CardProductSwatch);
}


/**
 *  @class
 *  @function CountdownTimer
 */

if (!customElements.get('count-down')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endTime = this.parseEndTime();
      this.timerId = null;
      this.elements = this.getElements();
      this.splitFlap = this.hasAttribute('data-split-flap');
      this.entranceDone = !this.splitFlap;
      this.previousValues = {};
      this._animationCancels = {};
      this._entranceIO = null;
    }

    parseEndTime() {
      const timeAttr = this.getAttribute('data-timer');
      const parsedTime = Date.parse(timeAttr);
      return isNaN(parsedTime) ? Date.now() : parsedTime;
    }

    getElements() {
      return {
        days: this.querySelector('[data-value="days"] .countdown-day'),
        hours: this.querySelector('[data-value="hours"] .countdown-hour'),
        minutes: this.querySelector('[data-value="minutes"] .countdown-minute'),
        seconds: this.querySelector('[data-value="seconds"] .countdown-second')
      };
    }

    formatValue(value) {
      return value.toString().padStart(2, '0');
    }

    _setUnitAriaLabel(el, value) {
      if (!el) return;
      el.setAttribute('aria-label', this.formatValue(value));
    }

    _updateTimerLabel(remainingTime) {
      if (!this.hasAttribute('aria-live')) return;

      const { days, hours, minutes, seconds } = remainingTime;
      this.setAttribute(
        'aria-label',
        `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`
      );
    }

    calculateTimeRemaining() {
      const now = Date.now();
      const total = Math.max(this.endTime - now, 0);
      return {
        total,
        days: Math.floor(total / (1000 * 60 * 60 * 24)),
        hours: Math.floor((total / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((total / (1000 * 60)) % 60),
        seconds: Math.floor((total / 1000) % 60)
      };
    }

    initializeDisplay() {
      if (this.splitFlap) {
        Object.keys(this.elements).forEach((key) => {
          if (this.elements[key]) {
            this.elements[key].textContent = '00';
          }
        });
        this.previousValues = { days: 0, hours: 0, minutes: 0, seconds: 0 };
      } else {
        this.updateDisplay(this.calculateTimeRemaining());
      }
    }

    startCountdown() {
      this.classList.add("active");

      this.timerId = setInterval(() => {
        const remainingTime = this.calculateTimeRemaining();

        if (remainingTime.total <= 0) {
          this.updateDisplay(remainingTime);
          this.stopCountdown();
          this.dispatchEvent(new CustomEvent('countdown-finished'));
          return;
        }

        this.updateDisplay(remainingTime);
      }, 1000);
    }

    updateDisplay(remainingTime) {
      if (!this.splitFlap) {
        Object.keys(this.elements).forEach((key) => {
          if (this.elements[key]) {
            this.elements[key].textContent = this.formatValue(remainingTime[key]);
          }
        });
        return;
      }

      if (!this.entranceDone) return;

      const flipFn = window.animateSecondsFlip;
      const tickDuration = 700;

      Object.keys(this.elements).forEach((key) => {
        const el = this.elements[key];
        if (!el) return;

        const nextVal = remainingTime[key];
        const prevVal = this.previousValues[key] ?? nextVal;

        if (prevVal === nextVal) return;

        if (this._animationCancels[key]) {
          this._animationCancels[key]();
        }

        if (key === 'seconds' && el.dataset.flipInit === 'true' && typeof flipFn === 'function') {
          const handle = flipFn(el, prevVal, nextVal, { duration: tickDuration });
          this._animationCancels[key] = handle.cancel;
        } else {
          el.textContent = this.formatValue(nextVal);
        }

        this._setUnitAriaLabel(el, nextVal);
        this.previousValues[key] = nextVal;
      });

      this._updateTimerLabel(remainingTime);
    }

    _initFlipStructure() {
      const initFn = window.initCountdownFlip;
      const el = this.elements.seconds;
      if (!el || typeof initFn !== 'function') return;
      const val = this.formatValue(this.previousValues.seconds ?? 0);
      initFn(el, val);
    }

    _initEntranceObserver() {
      const units = ['days', 'hours', 'minutes', 'seconds'];
      const entranceDuration = 2600;
      const stagger = 80;

      this._entranceIO = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          const remaining = this.calculateTimeRemaining();
          const animateFn = window.animateSplitFlap;

          units.forEach((key, i) => {
            const el = this.elements[key];
            if (!el) return;

            setTimeout(() => {
              const target = remaining[key];

              if (typeof animateFn === 'function') {
                const handle = animateFn(el, 0, target, { duration: entranceDuration });
                this._animationCancels[key] = handle.cancel;
              } else {
                el.textContent = this.formatValue(target);
              }

              this.previousValues[key] = target;
            }, i * stagger);
          });

          setTimeout(() => {
            const current = this.calculateTimeRemaining();
            Object.keys(this.elements).forEach((key) => {
              this.previousValues[key] = current[key];
              this._setUnitAriaLabel(this.elements[key], current[key]);
            });
            this._initFlipStructure();
            this._updateTimerLabel(current);
            this.entranceDone = true;
          }, units.length * stagger + entranceDuration);

          this._entranceIO.disconnect();
          this._entranceIO = null;
        },
        { threshold: 0.1 }
      );

      this._entranceIO.observe(this);
    }

    connectedCallback() {
      this.initializeDisplay();
      if (this.splitFlap) {
        this._initEntranceObserver();
      }
      setTimeout(() => this.startCountdown(), 50);
    }

    disconnectedCallback() {
      this.stopCountdown();
      this._entranceIO?.disconnect();
      Object.values(this._animationCancels).forEach((cancel) => cancel?.());
      this._animationCancels = {};
    }

    stopCountdown() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    }
  }

  customElements.define('count-down', CountdownTimer);
}

if (!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('.newsletter-form__message');
      const errorText = error.querySelector('.newsletter-form__message-error');
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const errorMessage = newsletterFormStrings.error;

      function validate() {
        if (!input.value) {
          error.style.display = 'none';
          errorText.textContent = '';
          button.disabled = true;
          return;
        }
        if (emailPattern.test(input.value)) {
          error.style.display = 'none';
          errorText.textContent = '';
          button.disabled = false;
        } else {
          errorText.textContent = errorMessage;
          error.style.display = 'flex';
          button.disabled = true;
        }
      }

      input.addEventListener('input', validate);

      form.addEventListener('submit', function(e) {
        if (!emailPattern.test(input.value)) {
          errorText.textContent = errorMessage;
          error.style.display = 'flex';
          button.disabled = true;
          e.preventDefault();
        } else {
          errorText.textContent = '';
          error.style.display = 'none';
          button.disabled = false;
        }
      });

      validate();
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}

if (!customElements.get('moving-button')) {
  class MovingButton extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.buttonRect = null;
      this.proximity = 50;
      this.isEffectActive = false;
      this.targetOffsetX = 0;
      this.targetOffsetY = 0;
      this.rafId = null;

      this.handleDocumentMouseMove = this.handleDocumentMouseMove.bind(this);
      this.cacheButtonPosition = this.cacheButtonPosition.bind(this);
      this.applyCurrentTransform = this.applyCurrentTransform.bind(this);
      this.handleScrollOrResize = this.handleScrollOrResize.bind(this);
    }

    static get observedAttributes() {
      return ['data-proximity'];
    }

    connectedCallback() {
      this.button = this.querySelector(".moving-button");
      if (!this.button) {
        return;
      }

      this.updateProximityFromAttribute();

      requestAnimationFrame(() => {
        this.cacheButtonPosition();
      });

      document.addEventListener('mousemove', this.handleDocumentMouseMove);
      window.addEventListener('scroll', this.handleScrollOrResize, { passive: true });
      window.addEventListener('resize', this.handleScrollOrResize);
    }

    disconnectedCallback() {
      document.removeEventListener('mousemove', this.handleDocumentMouseMove);
      window.removeEventListener('scroll', this.handleScrollOrResize);
      window.removeEventListener('resize', this.handleScrollOrResize);

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      if (this.button && this.isEffectActive) {
        this.button.style.willChange = 'auto';
        this.button.style.transform = 'translate3d(0px, 0px, 0px)';
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-proximity') {
        this.updateProximityFromAttribute();
      }
    }

    updateProximityFromAttribute() {
      const proximityAttr = this.getAttribute('data-proximity');
      if (proximityAttr !== null) {
        const parsedProximity = parseInt(proximityAttr, 10);
        if (!isNaN(parsedProximity) && parsedProximity >= 0) {
          this.proximity = parsedProximity;
        }
      }
    }

    cacheButtonPosition() {
      if (!this.button) return;
      this.buttonRect = this.button.getBoundingClientRect();
    }

    handleScrollOrResize() {
      this.cacheButtonPosition();
    }

    applyCurrentTransform() {
      if (!this.button) return;
      this.button.style.transform = `translate3d(${this.targetOffsetX}px, ${this.targetOffsetY}px, 0px)`;
      this.rafId = null;
    }

    handleDocumentMouseMove(e) {
      if (!this.button || !this.buttonRect) {
        return;
      }

      const mouseX_viewport = e.clientX;
      const mouseY_viewport = e.clientY;

      const zoneLeft = this.buttonRect.left - this.proximity;
      const zoneTop = this.buttonRect.top - this.proximity;
      const zoneRight = this.buttonRect.right + this.proximity;
      const zoneBottom = this.buttonRect.bottom + this.proximity;

      const mouseInZone = (
        mouseX_viewport >= zoneLeft && mouseX_viewport <= zoneRight &&
        mouseY_viewport >= zoneTop && mouseY_viewport <= zoneBottom
      );

      if (mouseInZone) {
        if (!this.isEffectActive) {
          this.isEffectActive = true;
          if (this.button) this.button.style.willChange = 'transform';
        }

        const buttonCenterX_viewport = this.buttonRect.left + this.buttonRect.width / 2;
        const buttonCenterY_viewport = this.buttonRect.top + this.buttonRect.height / 2;

        let offsetX = mouseX_viewport - buttonCenterX_viewport;
        let offsetY = mouseY_viewport - buttonCenterY_viewport;

        const maxMove = 20;
        this.targetOffsetX = Math.max(-maxMove, Math.min(maxMove, offsetX));
        this.targetOffsetY = Math.max(-maxMove, Math.min(maxMove, offsetY));

        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
        }
        this.rafId = requestAnimationFrame(this.applyCurrentTransform);

      } else {
        if (this.isEffectActive) {
          this.isEffectActive = false;
          if (this.button) {
            this.button.style.willChange = 'auto';
            this.button.style.transform = 'translate3d(0px, 0px, 0px)';
          }
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
        }
      }
    }
  }

  customElements.define("moving-button", MovingButton);
}


(function() {
  function getAbsoluteTop(element) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(event) {
      if (event.target.matches('[data-anchor]')) {
        event.preventDefault();
        
        const href = event.target.getAttribute('href');
        if (!href || href === '#') return;
        
        const targetId = href.replace('#', '');
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const targetPosition = getAbsoluteTop(targetSection) - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  }

  // Init when DOM is ready
  document.addEventListener('DOMContentLoaded', initSmoothScroll);
})();

(function() {
  const copyURL = () => {
    var button = document.querySelector('.share-button__copy');
    if (!button) return;
    button.addEventListener('click', function() {
      var url = button.getAttribute('data-url');
      navigator.clipboard.writeText(url).then(function() {
        button.classList.add('copied');
        setTimeout(function() {
          button.classList.remove('copied');
        }, 2000);
      }).catch(function(err) {
        console.error(err);
      });
    });

  }
  document.addEventListener("DOMContentLoaded", function() {
    copyURL();
  });
})()

if (!customElements.get('card-variant-size')) {
  customElements.define('card-variant-size', class extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification');
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const button = event.target.closest('.variant-size-button');
      if (!button || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const spinner = button.querySelector('.loading__spinner');

      this.loading = true;
      const allButtons = this.querySelectorAll('.variant-size-button');
      allButtons.forEach(btn => {
        btn.setAttribute('aria-disabled', true);
        btn.classList.add('disabled');
      });

      button.classList.add('loading');
      button.setAttribute('aria-disabled', true);
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (this.cart?.getSectionsToRender) {
        const sections = this.cart.getSectionsToRender().map((s) => s.id);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement?.(document.activeElement);
      }

      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(res => {
        if (!res.ok) return res.text().then(text => { throw new Error(text); });
        return res.json();
      })
      .then(data => {
        if (data.status) {
          console.warn(data.message || data.description);
          return;
        }

        if (this.cart?.renderContents) {
          this.cart.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        allButtons.forEach(btn => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('disabled', 'loading');
          btn.querySelector('.loading__spinner')?.classList.add('hidden');
        });
        this.loading = false;
      
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
      });      
    }
  });
}

if (!customElements.get('show-more-toggle')) {
  customElements.define(
    'show-more-toggle',
    class ShowMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-show-more-content]');
        this.button = this.querySelector('button');
        this.showMoreText = this.querySelector('.label-show-more');
        this.showLessText = this.querySelector('.label-show-less');

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        this.content.classList.toggle('content-truncated');
        this.showMoreText.classList.toggle('hidden');
        this.showLessText.classList.toggle('hidden');
      }
    }
  );
}

(function () {
  function initGalleryLoadMore() {
    document.querySelectorAll('.gallery-load-more').forEach(function (btn) {
      if (btn.dataset.loadMoreBound) return;
      btn.dataset.loadMoreBound = '1';
      btn.addEventListener('click', function () {
        var galleryId = btn.getAttribute('data-gallery-id');
        var carousel = galleryId ? document.getElementById(galleryId) : null;
        if (carousel) {
          carousel.classList.add('gallery--all-loaded');
        }
        var wrap = btn.closest('.gallery-load-more-wrap');
        if (wrap) wrap.classList.add('is-hidden');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGalleryLoadMore();
    document.addEventListener('shopify:section:load', function () {
      initGalleryLoadMore();
    });
  });
})();

(function () {
  let rafId;

  const updatePdpTitleBadgeAlignment = () => {
    document.querySelectorAll('.product__header-title-row').forEach((row) => {
      const title = row.querySelector('.product__header-title');
      // Every badge candidate is in the DOM; only the un-hidden one is measurable.
      const badge = row.querySelector('.product__header-badge:not(.hidden)');
      if (!title || !badge) {
        row.classList.remove('product__header-title-row--single-line');
        return;
      }

      const titleRect = title.getBoundingClientRect();
      const badgeRect = badge.getBoundingClientRect();
      const isWrappedUnderTitle = badgeRect.top >= titleRect.bottom - 1;

      row.classList.toggle('product__header-title-row--single-line', !isWrappedUnderTitle);
    });
  };

  const scheduleUpdate = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updatePdpTitleBadgeAlignment);
  };

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('pdp:header-badge-updated', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);
})();

